import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { TransactionStatus, formatSmallNumbers, ACTIVITY_ACTION_RECEIVE, ACTIVITY_ACTION_SEND, ACTIVITY_ACTION_REMOVE_TRUSTLINE, ACTIVITY_ACTION_CREATE_TRUSTLINE, ACTIVITY_ACTION_ACCEPT_NFT_OFFER, ACTIVITY_ACTION_CANCEL_NFT_OFFER, significantDigits, getTxStatusText, formatDate, formatTime, addressSlicer, randomId, ACTIVITY_ACTION_CREATE_NFT_OFFER, BaseController, BaseCurrencyController, BaseKeyringController, hashMessage, timeout, PROVIDER_JRPC_METHODS, createFetchMiddleware, createSwappableProxy, createEventEmitterProxy, BasePreferencesController, ACTIVITY_ACTION_TOPUP, TX_EVENTS, BaseTransactionStateManager, transactionMatchesNetwork } from '@toruslabs/base-controllers';
import { Mutex } from 'async-mutex';
import BigNumber, { BigNumber as BigNumber$1 } from 'bignumber.js';
import { has, get as get$1, isUndefined, flatMap, set, find, isNumber, toInteger, omitBy, mapValues, keyBy, sortBy, pickBy } from 'lodash';
import { post, get, patch, remove } from '@toruslabs/http-helpers';
import log from 'loglevel';
import { convertHexToString, Wallet } from 'xrpl';
import { HTTPTransport, RequestManager, Client } from '@open-rpc/client-js';
import { JSONRPCError, ERR_UNKNOWN } from '@open-rpc/client-js/build/Error';
import { getNotifications, getBatchRequests } from '@open-rpc/client-js/build/Request';
import { Transport } from '@open-rpc/client-js/build/transports/Transport';
import { generateSeed, sign } from 'ripple-keypairs';
import ECDSA from 'xrpl/dist/npm/ECDSA';
import { createAsyncMiddleware, mergeMiddleware, createScaffoldMiddleware, providerFromMiddleware, JRPCEngine, providerFromEngine } from '@toruslabs/openlogin-jrpc';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { validateBaseTransaction } from 'xrpl/dist/npm/models/transactions/common';
import { validatePayment } from 'xrpl/dist/npm/models/transactions/payment';
import * as AccountLib from 'xrpl-accountlib';
import { validateTrustSet } from 'xrpl/dist/npm/models/transactions/trustSet';

const DefaultXrplNetworkArray = ["mainnet", "testnet", "devnet"];
const MessageStatus = {
  UNAPPROVED: "unapproved",
  SIGNED: "signed",
  REJECTED: "rejected",
  FAILED: "failed"
};
let TransactionTypes = /*#__PURE__*/function (TransactionTypes) {
  TransactionTypes["Payment"] = "Payment";
  TransactionTypes["TrustSet"] = "TrustSet";
  TransactionTypes["NFTokenCreateOffer"] = "NFTokenCreateOffer";
  TransactionTypes["NFTokenAcceptOffer"] = "NFTokenAcceptOffer";
  TransactionTypes["NFTokenCancelOffer"] = "NFTokenCancelOffer";
  TransactionTypes["Others"] = "Others";
  return TransactionTypes;
}({});
let LoadingState = /*#__PURE__*/function (LoadingState) {
  LoadingState["FULL_RELOAD"] = "full_reload";
  LoadingState["LOADED"] = "loaded";
  LoadingState["ERROR"] = "fetching_error";
  return LoadingState;
}({});

/**
 * Account information object
 */

/**
 * Account tracker controller state
 */

const DEFAULT_XRPL_NETWORK = {
  mainnet: "mainnet",
  testnet: "testnet",
  devnet: "devnet"
};
const DEFAULT_XRPL_CHAIN_NETWORK_KEYS = Object.values(DEFAULT_XRPL_NETWORK);
const DEFAULT_XRPL_CHAIN_CONFIGS = [{
  chainId: "0x1",
  logo: "https://images.toruswallet.io/XRP.svg",
  rpcTarget: "https://ripple-node.tor.us",
  wsTarget: "wss://s2.ripple.com",
  ticker: "XRP",
  tickerName: "XRPL",
  displayName: "xrpl mainnet",
  blockExplorerUrl: "https://livenet.xrpl.org",
  networkKey: DEFAULT_XRPL_NETWORK.mainnet
}, {
  chainId: "0x2",
  logo: "https://images.toruswallet.io/XRP.svg",
  rpcTarget: "https://testnet-ripple-node.tor.us",
  wsTarget: "wss://s.altnet.rippletest.net",
  ticker: "XRP",
  tickerName: "XRPL",
  displayName: "xrpl testnet",
  blockExplorerUrl: "https://testnet.xrpl.org",
  networkKey: DEFAULT_XRPL_NETWORK.testnet,
  isTestnet: true
}, {
  chainId: "0x3",
  logo: "https://images.toruswallet.io/XRP.svg",
  rpcTarget: "https://devnet-ripple-node.tor.us",
  wsTarget: "wss://s.devnet.rippletest.net/",
  ticker: "XRP",
  tickerName: "XRPL",
  displayName: "xrpl devnet",
  blockExplorerUrl: "https://devnet.xrpl.org",
  networkKey: DEFAULT_XRPL_NETWORK.devnet,
  isTestnet: true
}];
const CHAINS = {
  XRPL_MAINNET: "mainnet",
  XRPL_TESTNET: "testnet",
  XRPL_DEVNET: "devnet"
};
const CHAIN_ID_NETWORK_MAP = {
  "0x1": CHAINS.XRPL_MAINNET,
  "0x2": CHAINS.XRPL_TESTNET,
  "0x3": CHAINS.XRPL_DEVNET
};
const MESSAGE_EVENTS = {
  UNAPPROVED_MSG: "msg:unapproved"
};

// xrpl.org/ripplestate.html#ripplestate-flags
const LedgerObjectFlags = {
  RippleState: {
    lsfLowReserve: 0x00010000,
    lsfHighReserve: 0x00020000,
    lsfLowNoRipple: 0x00100000,
    lsfHighNoRipple: 0x00200000
  }
};
const NATIVE_TRANSFER_GAS = new BigNumber(10);
const TRANSFER_MINIMUM_AMOUNT = new BigNumber(1); // 1 drop (0.000001 xrp)

const TOKEN_PRICE_AGGREGATOR_URL = "https://api.onthedex.live/public/v1/aggregator";
const OTHER_TRANSACTIONS = "Others";
const SUPPORTED_SUBMIT_TRANSACTION_TYPES = {
  [TransactionTypes.Payment]: TransactionTypes.Payment,
  [TransactionTypes.TrustSet]: TransactionTypes.TrustSet,
  [TransactionTypes.NFTokenCreateOffer]: TransactionTypes.NFTokenCreateOffer,
  [TransactionTypes.NFTokenCancelOffer]: TransactionTypes.NFTokenCancelOffer,
  [TransactionTypes.NFTokenAcceptOffer]: TransactionTypes.NFTokenAcceptOffer
};
const XRPL_TRANSACTION_TYPES = _objectSpread(_objectSpread({}, SUPPORTED_SUBMIT_TRANSACTION_TYPES), {}, {
  [OTHER_TRANSACTIONS]: OTHER_TRANSACTIONS
});
const RIPPLE_TESTNET_FAUCET_URL = "https://faucet.altnet.rippletest.net/accounts";
const CDBC_FAUCET_URL = "https://dev.faucet.cbdc.xpring.dev/accounts/";
const DEFAULT_CDBC_FAUCET_FUND_AMOUNT = "10000";
const RIPPLE_SANDBOX_API_ISSUED_CURRENCIES = "https://dcm.ripplesandbox.com/api/issued-currencies";
const RIPPLE_API_ISSUED_CURRENCIES = "https://dcm.ripple.com/api/issued-currencies";
const XRPL_META_TOKENS_BASE_URL = "https://s1.xrplmeta.org";

// initial xrpl chain config
const getDefaultXRPLChainConfig = networkKey => {
  const defaultConfig = DEFAULT_XRPL_CHAIN_CONFIGS.find(cfg => cfg.networkKey === networkKey);
  if (!defaultConfig) {
    throw new Error(`Unsupported network: ${networkKey}`);
  }
  return defaultConfig;
};
const _checkIfTxExpired = (lastLedgerSequence, txHash, ledgerIndex) => {
  if (ledgerIndex && lastLedgerSequence < ledgerIndex) {
    log.warn(`transaction with tx hash: ${txHash} is expired},tx expiry sequence: ${lastLedgerSequence}, current ledger index: ${ledgerIndex}`);
    return true;
  }
  return false;
};
const getTransactionType = tx => {
  if (tx.TransactionType === TransactionTypes.Payment) {
    return TransactionTypes.Payment;
  } else if (tx.TransactionType === TransactionTypes.TrustSet) {
    return TransactionTypes.TrustSet;
  } else if (tx.TransactionType === TransactionTypes.NFTokenAcceptOffer) {
    return TransactionTypes.NFTokenAcceptOffer;
  } else if (tx.TransactionType === TransactionTypes.NFTokenCreateOffer) {
    return TransactionTypes.NFTokenCreateOffer;
  } else if (tx.TransactionType === TransactionTypes.NFTokenCancelOffer) {
    return TransactionTypes.NFTokenCancelOffer;
  }
  return TransactionTypes.Others;
};
const getTxStatus = _ref => {
  let {
    txValidated,
    hash,
    lastLedgerSequence,
    ledgerIndex,
    txResult
  } = _ref;
  if (!txValidated) {
    const isExpired = _checkIfTxExpired(lastLedgerSequence, hash, ledgerIndex);
    if (isExpired) {
      return TransactionStatus.expired;
    }
    return TransactionStatus.submitted;
  }
  if (txValidated) {
    if (txResult === "tesSUCCESS") {
      return TransactionStatus.confirmed;
    }
    return TransactionStatus.failed;
  }
};
const isHex40Currency = str => {
  return /^[0-9a-fA-F]{40}$/.test(str);
};
const parseCurrencyToReadableFormat = currency => {
  const hexToString = hex => {
    // eslint-disable-next-line no-control-regex
    return convertHexToString(hex).replace(/\u0000/g, "");
  };
  return isHex40Currency(currency) ? hexToString(currency) : currency;
};
const formatNewTransaction = (tx, currencyData, selectedAddress, chainConfig, nftInfo) => {
  var _ref2, _tx$transaction, _ref3, _to;
  const txCategory = getTransactionType(tx.transaction);
  const from = tx.transaction.Account;
  const fromPubKey = tx.transaction.SigningPubKey || "";
  const txFee = new BigNumber((_ref2 = tx.transaction.Fee) !== null && _ref2 !== void 0 ? _ref2 : 0);
  let to = (_tx$transaction = tx.transaction) === null || _tx$transaction === void 0 ? void 0 : _tx$transaction.Destination;
  let txAmount = new BigNumber((_ref3 = tx.transaction.Amount) !== null && _ref3 !== void 0 ? _ref3 : 0);
  let totalAmount = new BigNumber(txAmount).div(10 ** 6);
  let totalCurrencyAmount = totalAmount.multipliedBy(currencyData.conversionRate);
  let currencyUsed = currencyData.selectedCurrency;
  let totalAmountString = formatSmallNumbers(totalAmount.toNumber(), currencyData.networkNativeCurrency.toUpperCase(), true);
  let currencyAmountString = formatSmallNumbers(totalCurrencyAmount.toNumber(), currencyUsed, true);
  let action = selectedAddress.toLocaleLowerCase() === ((_to = to) === null || _to === void 0 ? void 0 : _to.toLocaleLowerCase()) ? ACTIVITY_ACTION_RECEIVE : ACTIVITY_ACTION_SEND;
  let ticker = tx.ticker || "XRP";
  if (txCategory === TransactionTypes.Payment && typeof tx.transaction.Amount === "object") {
    // Non-xrp payment
    const amount = tx.transaction.Amount;
    const currency = parseCurrencyToReadableFormat(amount.currency);
    txAmount = new BigNumber(amount.value);
    totalAmount = new BigNumber(txAmount);
    totalCurrencyAmount = new BigNumber(0);
    currencyUsed = `${currency}-${amount.issuer}`;
    totalAmountString = `${totalAmount.toNumber()} ${currency}`;
    currencyAmountString = "";
    ticker = currency;
  }
  if (txCategory === TransactionTypes.TrustSet) {
    const limitAmount = tx.transaction.LimitAmount;
    const currency = parseCurrencyToReadableFormat(limitAmount.currency);
    to = limitAmount.issuer;
    txAmount = new BigNumber(limitAmount.value);
    totalAmount = new BigNumber(limitAmount.value);
    totalCurrencyAmount = new BigNumber(0);
    currencyUsed = `${currency}-${limitAmount.issuer}`;
    totalAmountString = `${totalAmount.toNumber()} ${currency}`;
    currencyAmountString = "";
    action = totalAmount.isZero() ? ACTIVITY_ACTION_REMOVE_TRUSTLINE : ACTIVITY_ACTION_CREATE_TRUSTLINE;
    ticker = currency;
  }
  const nftOfferObject = {};
  if (txCategory === TransactionTypes.NFTokenCreateOffer && nftInfo) {
    var _nftDetails$metadata, _nftDetails$metadata2, _nftDetails$metadata3;
    const nftDetails = nftInfo;
    nftOfferObject.nft_token_id = tx.transaction.NFTokenID;
    nftOfferObject.offer_type = tx.transaction.Flags === 1 ? "sell" : "buy";
    nftOfferObject.nft_image_uri = (nftDetails === null || nftDetails === void 0 || (_nftDetails$metadata = nftDetails.metadata) === null || _nftDetails$metadata === void 0 ? void 0 : _nftDetails$metadata.image) || "";
    nftOfferObject.nft_description = (nftDetails === null || nftDetails === void 0 || (_nftDetails$metadata2 = nftDetails.metadata) === null || _nftDetails$metadata2 === void 0 ? void 0 : _nftDetails$metadata2.description) || "";
    nftOfferObject.nft_title = (nftDetails === null || nftDetails === void 0 || (_nftDetails$metadata3 = nftDetails.metadata) === null || _nftDetails$metadata3 === void 0 ? void 0 : _nftDetails$metadata3.name) || "";
    action = ACTIVITY_ACTION_CREATE_NFT_OFFER;
    currencyUsed = nftOfferObject.nft_token_id;
  }
  if ([TransactionTypes.NFTokenAcceptOffer, TransactionTypes.NFTokenCancelOffer].includes(txCategory) && nftInfo) {
    const nftOffer = nftInfo;
    nftOfferObject.nft_offer_index = nftOffer.nftOfferIndex;
    // nftInfo stores offers created from NFTokenCreateOffer tx
    to = from === nftOffer.to ? nftOffer.from : nftOffer.to;
    action = txCategory === TransactionTypes.NFTokenAcceptOffer ? ACTIVITY_ACTION_ACCEPT_NFT_OFFER : ACTIVITY_ACTION_CANCEL_NFT_OFFER;
    currencyUsed = nftOfferObject.nft_offer_index;
  }
  const rate = !totalAmount.isZero() && !totalCurrencyAmount.isZero() ? `1 ${currencyData.networkNativeCurrency.toUpperCase()} = ${significantDigits(totalCurrencyAmount.div(totalAmount).toNumber())}` : "";
  const isoDateString = new Date(tx.time).toISOString();
  const xrplLink = `${chainConfig.blockExplorerUrl}/transactions/${tx.transactionHash}`;
  const finalObject = _objectSpread({
    id: tx.id.toString(),
    ticker,
    transactionCategory: txCategory,
    statusText: getTxStatusText(tx.status),
    rawDate: isoDateString,
    dateFormatted: formatDate(isoDateString),
    timeFormatted: formatTime(isoDateString),
    from,
    slicedFrom: addressSlicer(from),
    to,
    slicedTo: addressSlicer(to),
    fromPubKey,
    slicedFromPubKey: addressSlicer(fromPubKey),
    action,
    totalAmount: totalAmount.toNumber(),
    totalAmountString,
    currencyAmount: totalCurrencyAmount.toNumber(),
    currencyAmountString,
    status: tx.status,
    explorerLink: xrplLink || "",
    network: tx.chainId,
    chainId: chainConfig.chainId || tx.chainId,
    rate,
    currencyUsed,
    transactionHash: tx.transactionHash,
    fee: new BigNumber(txFee).div(10 ** 6).toString(),
    feeString: `${new BigNumber(txFee).div(10 ** 6).toString()} XRP`,
    isCancel: false
  }, nftOfferObject);
  return finalObject;
};
const formatPastTx = (tx, currentAddress, blockExplorerUrl) => {
  let totalAmountString = formatSmallNumbers(Number.parseFloat(tx.total_amount), "XRP", true);
  let currencyAmountString = formatSmallNumbers(Number.parseFloat(tx.currency_amount), tx.selected_currency, true);
  let action = currentAddress.toLocaleLowerCase() === tx.to.toLowerCase() || "" ? ACTIVITY_ACTION_RECEIVE : ACTIVITY_ACTION_SEND;
  let ticker = tx.ticker || "XRP";
  if (tx.transaction_category === TransactionTypes.Payment && Number(tx.currency_amount) === 0) {
    // Non-xrp payment
    const currency = tx.selected_currency.split("-")[0];
    totalAmountString = `${Number.parseFloat(tx.total_amount)} ${currency}`;
    currencyAmountString = "";
    ticker = currency;
  }
  if (tx.transaction_category === TransactionTypes.TrustSet) {
    const currency = tx.selected_currency.split("-")[0];
    totalAmountString = `${Number.parseFloat(tx.total_amount)} ${currency}`;
    currencyAmountString = "";
    action = Number(tx.total_amount) === 0 ? ACTIVITY_ACTION_REMOVE_TRUSTLINE : ACTIVITY_ACTION_CREATE_TRUSTLINE;
    ticker = currency;
  }
  if (tx.transaction_category === TransactionTypes.NFTokenCreateOffer) {
    action = ACTIVITY_ACTION_CREATE_NFT_OFFER;
  }
  if ([TransactionTypes.NFTokenAcceptOffer, TransactionTypes.NFTokenCancelOffer].includes(tx.transaction_category)) {
    action = tx.transaction_category === TransactionTypes.NFTokenAcceptOffer ? ACTIVITY_ACTION_ACCEPT_NFT_OFFER : ACTIVITY_ACTION_CANCEL_NFT_OFFER;
  }
  const finalObject = {
    id: tx.id.toString(),
    ticker,
    transactionCategory: tx.transaction_category,
    statusText: getTxStatusText(tx.status),
    rawDate: tx.created_at,
    dateFormatted: formatDate(tx.created_at),
    timeFormatted: formatTime(tx.created_at),
    from: tx.from,
    slicedFrom: addressSlicer(tx.from),
    to: tx.to,
    slicedTo: addressSlicer(tx.to),
    fromPubKey: tx.fromPubKey,
    slicedFromPubKey: addressSlicer(tx.fromPubKey || ""),
    action,
    totalAmount: Number.parseFloat(tx.total_amount),
    totalAmountString,
    currencyAmount: Number.parseFloat(tx.currency_amount),
    currencyAmountString,
    status: tx.status,
    explorerLink: blockExplorerUrl ? `${blockExplorerUrl}/transactions/${tx.transaction_hash}` : "",
    network: CHAIN_ID_NETWORK_MAP[tx.chain_id],
    chainId: tx.chain_id,
    rate: Number.parseFloat(tx === null || tx === void 0 ? void 0 : tx.total_amount) && Number.parseFloat(tx === null || tx === void 0 ? void 0 : tx.currency_amount) ? `1 XRP = ${significantDigits(Number.parseFloat(tx.currency_amount) / Number.parseFloat(tx.total_amount))}` : "",
    currencyUsed: tx.selected_currency,
    transactionHash: tx.transaction_hash,
    fee: new BigNumber(tx.fee).div(10 ** 6).toString(),
    feeString: `${new BigNumber(tx.fee).div(10 ** 6).toString()} XRP`,
    isCancel: tx.is_cancel
  };
  return finalObject;
};
const formatTxToSave = tx => {
  let finalObject = {
    from: tx.from,
    to: tx.to,
    fromPubKey: tx.fromPubKey,
    total_amount: tx.totalAmount.toString(),
    currency_amount: tx.currencyAmount.toString(),
    selected_currency: tx.currencyUsed,
    status: tx.status,
    transaction_hash: tx.transactionHash,
    fee: tx.fee.toString(),
    transaction_category: tx.transactionCategory,
    is_cancel: tx.isCancel,
    chain_id: tx.chainId,
    created_at: tx.rawDate
  };

  // add nft txn metadata fields
  if (tx.nft_token_id) {
    finalObject = _objectSpread(_objectSpread({}, finalObject), {}, {
      nft_token_id: tx.nft_token_id,
      offer_type: tx.offer_type
    });
    if (tx.nft_title) finalObject.nft_title = tx.nft_title;
    if (tx.nft_description) finalObject.nft_description = tx.nft_description;
    if (tx.nft_image_uri) finalObject.nft_image_uri = tx.nft_image_uri;
  }
  if (tx.nft_offer_index) {
    finalObject = _objectSpread(_objectSpread({}, finalObject), {}, {
      nft_offer_index: tx.nft_offer_index
    });
  }
  return finalObject;
};
const formatAccountTx = (transaction, currencyData, selectedAddress, chainId, blockExplorerUrl) => {
  var _ref4, _txPayment$Amount, _to2, _transaction$meta;
  const {
    tx
  } = transaction;
  const txCategory = getTransactionType(tx);
  const from = tx.Account;
  const fromPubKey = tx.SigningPubKey;
  const txFee = new BigNumber((_ref4 = tx.Fee) !== null && _ref4 !== void 0 ? _ref4 : 0);
  const txPayment = tx;
  let to = txPayment.Destination;
  const txAmount = new BigNumber((_txPayment$Amount = txPayment.Amount) === null || _txPayment$Amount === void 0 ? void 0 : _txPayment$Amount.toString());
  let totalAmount = new BigNumber(txAmount).div(10 ** 6);
  let totalCurrencyAmount = totalAmount.multipliedBy(currencyData.conversionRate);
  let currencyUsed = currencyData.selectedCurrency;
  let totalAmountString = formatSmallNumbers(totalAmount.toNumber(), currencyData.networkNativeCurrency.toUpperCase(), true);
  let currencyAmountString = formatSmallNumbers(totalCurrencyAmount.toNumber(), currencyUsed, true);
  let action = selectedAddress.toLocaleLowerCase() === ((_to2 = to) === null || _to2 === void 0 ? void 0 : _to2.toLocaleLowerCase()) ? ACTIVITY_ACTION_RECEIVE : ACTIVITY_ACTION_SEND;
  let ticker = "XRP";
  if (txCategory === TransactionTypes.Payment && typeof txPayment.Amount === "object") {
    // Non-xrp payment
    const currency = parseCurrencyToReadableFormat(txPayment.Amount.currency);
    totalAmount = new BigNumber(txPayment.Amount.value);
    totalCurrencyAmount = new BigNumber(0);
    currencyUsed = `${currency}-${txPayment.Amount.issuer}`;
    totalAmountString = `${totalAmount.toNumber()} ${currency}`;
    currencyAmountString = "";
    ticker = currency;
  }
  if (txCategory === TransactionTypes.TrustSet) {
    const txTrustSet = tx;
    const limitAmount = txTrustSet.LimitAmount;
    const currency = parseCurrencyToReadableFormat(limitAmount.currency);
    to = limitAmount.issuer;
    totalAmount = new BigNumber(limitAmount.value);
    totalCurrencyAmount = new BigNumber(0);
    currencyUsed = `${currency}-${limitAmount.issuer}`;
    totalAmountString = `${totalAmount.toNumber()} ${currency}`;
    currencyAmountString = "";
    action = totalAmount.isZero() ? ACTIVITY_ACTION_REMOVE_TRUSTLINE : ACTIVITY_ACTION_CREATE_TRUSTLINE;
    ticker = currency;
  }
  if (txCategory === TransactionTypes.NFTokenCreateOffer) {
    const txCreateNftOffer = tx;
    action = ACTIVITY_ACTION_CREATE_NFT_OFFER;
    currencyUsed = txCreateNftOffer.NFTokenID;
  }
  const getAccountRoots = (txMeta, ignoreAccount) => {
    return txMeta.AffectedNodes.reduce((arr, node) => {
      if ("ModifiedNode" in node && node.ModifiedNode.LedgerEntryType === "AccountRoot") {
        var _node$ModifiedNode$Fi, _node$ModifiedNode$Fi2;
        const account = (_node$ModifiedNode$Fi = (_node$ModifiedNode$Fi2 = node.ModifiedNode.FinalFields) === null || _node$ModifiedNode$Fi2 === void 0 ? void 0 : _node$ModifiedNode$Fi2.Account) !== null && _node$ModifiedNode$Fi !== void 0 ? _node$ModifiedNode$Fi : "";
        if (account.toLocaleLowerCase() !== ignoreAccount.toLocaleLowerCase()) {
          arr.push(account);
        }
      }
      return arr;
    }, []);
  };
  if (txCategory === TransactionTypes.NFTokenAcceptOffer) {
    var _txAcceptNftOffer$met;
    const txAcceptNftOffer = transaction;
    if (typeof transaction.meta !== "string") {
      const accountRoots = getAccountRoots(transaction.meta, from);
      to = accountRoots.length ? accountRoots[0] : to;
    }
    action = ACTIVITY_ACTION_ACCEPT_NFT_OFFER;
    // Will be undefined when `TransactionResult` is "tecOBJECT_NOT_FOUND"
    currencyUsed = (_txAcceptNftOffer$met = txAcceptNftOffer.meta.nftoken_id) !== null && _txAcceptNftOffer$met !== void 0 ? _txAcceptNftOffer$met : "";
  }
  if (txCategory === TransactionTypes.NFTokenCancelOffer) {
    var _txCancelNftOffer$met;
    const txCancelNftOffer = transaction;
    if (typeof transaction.meta !== "string") {
      const accountRoots = getAccountRoots(transaction.meta, from);
      to = accountRoots.length ? accountRoots[0] : to;
    }
    action = ACTIVITY_ACTION_CANCEL_NFT_OFFER;
    // Will be undefined when `TransactionResult` is "tecOBJECT_NOT_FOUND"
    currencyUsed = (_txCancelNftOffer$met = txCancelNftOffer.meta.nftoken_ids[0]) !== null && _txCancelNftOffer$met !== void 0 ? _txCancelNftOffer$met : "";
  }
  const rate = !totalAmount.isZero() && !totalCurrencyAmount.isZero() ? `1 ${currencyData.networkNativeCurrency.toUpperCase()} = ${significantDigits(totalCurrencyAmount.div(totalAmount).toNumber())}` : "";
  const isoDateString = new Date((tx.date + 946684800) * 1000).toISOString();
  const status = getTxStatus({
    txValidated: transaction.validated,
    hash: tx.hash,
    lastLedgerSequence: tx.LastLedgerSequence,
    ledgerIndex: tx.ledger_index,
    txResult: (_transaction$meta = transaction.meta) === null || _transaction$meta === void 0 ? void 0 : _transaction$meta.TransactionResult
  });
  const finalObject = {
    id: randomId(),
    ticker,
    // TODO: add ticker in backend
    transactionCategory: txCategory,
    statusText: getTxStatusText(status),
    rawDate: isoDateString,
    dateFormatted: formatDate(isoDateString),
    timeFormatted: formatTime(isoDateString),
    from,
    slicedFrom: addressSlicer(from),
    to,
    slicedTo: addressSlicer(to),
    fromPubKey,
    slicedFromPubKey: addressSlicer(fromPubKey),
    action,
    totalAmount: totalAmount.toNumber(),
    totalAmountString,
    currencyAmount: totalCurrencyAmount.toNumber(),
    currencyAmountString,
    status,
    network: CHAIN_ID_NETWORK_MAP[chainId],
    explorerLink: blockExplorerUrl ? `${blockExplorerUrl}/transactions/${tx.hash}` : "",
    chainId,
    rate,
    currencyUsed,
    transactionHash: tx.hash,
    fee: txFee.toString(),
    isCancel: false,
    feeString: `${new BigNumber(txFee).div(10 ** 6).toString()} XRP`
  };
  return finalObject;
};

// fund new account from Xrpl Faucet in testnet/devnet
const fundAccountFromXrplFaucet = async (address, network) => {
  try {
    if (network === "mainnet") {
      return;
    }
    if (network === "testnet") {
      const body = {
        destination: address,
        memos: [{
          data: "xrpl.tor.us"
        }]
      };
      const resp = await post(RIPPLE_TESTNET_FAUCET_URL, body);
      return resp;
    }
    // fund for devnet
    const data = {
      destination: address,
      xrpAmount: DEFAULT_CDBC_FAUCET_FUND_AMOUNT
    };
    const resp = await post(CDBC_FAUCET_URL, data);
    return resp;
  } catch (err) {
    log.error("[Error] fundAccountFromFaucet::", err);
  }
};
const getSupportedTokensOmitPrice = async (api, network) => {
  const url = `${api}/tokens/supported?network=${network}`;
  const resp = await get(url, {
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  });
  return resp;
};
const getTokensPrice = async tokens => post(TOKEN_PRICE_AGGREGATOR_URL, {
  tokens
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any

class ProviderTransport extends Transport {
  constructor(provider) {
    super();
    _defineProperty(this, "provider", void 0);
    _defineProperty(this, "onlyNotifications", data => {
      if (data instanceof Array) {
        return data.every(datum => datum.request.request.id === null || datum.request.request.id === undefined);
      }
      return data.request.id === null || data.request.id === undefined;
    });
    this.provider = provider;
  }
  connect() {
    return Promise.resolve();
  }
  async sendData(data) {
    let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const prom = this.transportRequestManager.addRequest(data, timeout);
    const notifications = getNotifications(data);
    const batch = getBatchRequests(data);
    try {
      const result = await this.provider.sendAsync(data.request);
      const jsonrpcResponse = {
        id: data.request.id,
        jsonrpc: data.request.jsonrpc,
        result,
        error: null
      };
      // requirements are that notifications are successfully sent
      this.transportRequestManager.settlePendingRequest(notifications);
      if (this.onlyNotifications(data)) {
        return await Promise.resolve();
      }
      const responseErr = this.transportRequestManager.resolveResponse(JSON.stringify(jsonrpcResponse));
      if (responseErr) {
        throw responseErr;
      }
    } catch (e) {
      const responseErr = new JSONRPCError(e.message, ERR_UNKNOWN, e);
      this.transportRequestManager.settlePendingRequest(notifications, responseErr);
      // requirements are that batch requests are successfully resolved
      // this ensures that individual requests within the batch request are settled
      this.transportRequestManager.settlePendingRequest(batch, responseErr);
      return Promise.reject(responseErr);
    }
    return prom;
  }
  close() {}
}

class XrplJrpcService {
  constructor(provider) {
    _defineProperty(this, "client", void 0);
    _defineProperty(this, "jrpcTarget", void 0);
    let transport;
    if (typeof provider === "string") {
      this.jrpcTarget = provider;
      transport = new HTTPTransport(provider);
    } else {
      transport = new ProviderTransport(provider);
    }
    const requestManager = new RequestManager([transport]);
    this.client = new Client(requestManager);
  }
  async ping() {
    const res = await post(this.jrpcTarget, {
      method: "ping",
      params: [{}]
    });
    log.info("ping res", res);
    return res.result;
  }
  async getLatestLedgerState() {
    let ledgerIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "validated";
    const response = await this.client.request({
      method: "ledger",
      params: [{
        ledger_index: ledgerIndex,
        full: false,
        accounts: false,
        transactions: false,
        expand: false,
        owner_funds: false
      }]
    });
    if (response.status === "success") {
      return response;
    }
    throw new Error(`${response.error_message}${response.error}`);
  }
  async getAccountInfo(accountAddress, ledgerIndex) {
    const response = await this.client.request({
      method: "account_info",
      params: [{
        account: accountAddress,
        ledger_index: ledgerIndex || "validated"
      }]
    });
    log.info("account respine", response);
    if (response.status === "success") {
      return response;
    }
    throw new Error(`${response.error_message}${response.error}`);
  }
  async getAccountTransactions(request) {
    const response = await this.client.request({
      method: "account_tx",
      params: [_objectSpread({}, request)]
    });
    if (response.status === "success") {
      return response;
    }
    throw new Error(`${response.error_message}${response.error}`);
  }
  async getLedgerFee() {
    const response = await this.client.request({
      method: "fee",
      params: [{}]
    });
    log.info("response ledger fee", response);
    if (response.status === "success") {
      return response;
    }
    throw new Error(`${response.error_message}${response.error}`);
  }
  async getTransactionStatus(txHash) {
    const response = await this.client.request({
      method: "tx",
      params: [{
        transaction: txHash,
        binary: false
      }]
    });
    const err = response === null || response === void 0 ? void 0 : response.error;
    if (err) {
      if (err === "txnNotFound") {
        return {
          txValidated: false,
          txReceipt: undefined
        };
      }
      throw new Error(err);
    }
    if (response.status === "success" && response !== null && response !== void 0 && response.validated) {
      return {
        txValidated: true,
        txReceipt: response
      };
    }
    return {
      txValidated: false,
      txReceipt: undefined
    };
  }
  async submitTransaction(txBlob) {
    const response = await this.client.request({
      method: "submit",
      params: [{
        tx_blob: txBlob
      }]
    });
    if (response.status === "success") {
      return response;
    }
    throw new Error(`${response.error_message}${response.error}`);
  }
  async getLedgerEntry(req) {
    const response = await this.client.request({
      method: "ledger_entry",
      params: [_objectSpread({}, req)]
    });
    if (response.status === "success") {
      return response;
    }
    throw new Error(`${response.error_message}${response.error}`);
  }
  async getAccountLines(req) {
    const response = await this.client.request({
      method: "account_lines",
      params: [_objectSpread({}, req)]
    });
    if (response.status === "success") {
      const res = response;
      const trustlineMap = res.lines.reduce((arr, line) => {
        // Convert currencies in hex format to readable string
        const currency = parseCurrencyToReadableFormat(line.currency);
        // Ignore standard currencies in hex format
        if (currency.length === 3 && isHex40Currency(line.currency)) {
          return arr;
        }
        arr.push(_objectSpread(_objectSpread({}, line), {}, {
          currency
        }));
        return arr;
      }, []);
      res.lines = Object.values(trustlineMap);
      return res;
    }
    throw new Error(`${response.error_message}${response.error}`);
  }
}

/**
 * Tracks accounts based on blocks.
 * If block tracker provides latest block, we query accounts from it.
 * Preferences state changes also retrigger accounts update.
 * Network state changes also retrigger accounts update.
 */
class AccountTrackerController extends BaseController {
  constructor(_ref) {
    let {
      config,
      state,
      provider,
      ledgerTracker,
      getCurrentChainId,
      getIdentities,
      onPreferencesStateChange
    } = _ref;
    super({
      config,
      state
    });
    _defineProperty(this, "xrplJRPC", void 0);
    _defineProperty(this, "provider", void 0);
    _defineProperty(this, "ledgerTracker", void 0);
    _defineProperty(this, "mutex", new Mutex());
    _defineProperty(this, "getIdentities", void 0);
    _defineProperty(this, "getCurrentChainId", void 0);
    _defineProperty(this, "getAccountSequence", async account => {
      const accountInfo = await this.xrplJRPC.getAccountInfo(account);
      if (has(accountInfo, ["account_data", "Sequence"])) {
        const {
          account_data: accountData
        } = accountInfo;
        return Number(accountData.Sequence);
      }
      throw new Error("Unable to fetch account sequence");
    });
    this.defaultState = {
      accounts: {}
    };
    this.defaultConfig = {
      _currentLedgerState: null
    };
    this.initialize();
    this.provider = provider;
    this.ledgerTracker = ledgerTracker;
    this.xrplJRPC = new XrplJrpcService(this.provider);
    this.getIdentities = getIdentities;
    this.getCurrentChainId = getCurrentChainId;
    onPreferencesStateChange(() => {
      this.syncAccounts();
      this.refresh();
    });
  }
  syncAccounts() {
    const {
      accounts
    } = this.state;
    const identities = this.getIdentities();
    const addresses = Object.keys(identities);
    const existing = Object.keys(accounts);
    const newAddresses = addresses.filter(address => existing.indexOf(address) === -1);
    const oldAddresses = existing.filter(address => addresses.indexOf(address) === -1);
    newAddresses.forEach(address => {
      accounts[address] = {
        balance: "0",
        reservedBalance: "0",
        cacheIndexes: [],
        type: identities[address].accountType
      };
    });
    oldAddresses.forEach(address => {
      delete accounts[address];
    });
    this.update({
      accounts: _objectSpread({}, accounts)
    });
  }
  async refresh() {
    const releaseLock = await this.mutex.acquire();
    try {
      const {
        accounts
      } = this.state;
      const currentLedgerState = this.config._currentLedgerState;
      if (!currentLedgerState) return;
      const addresses = Object.keys(accounts);
      if (addresses.length > 0) {
        await Promise.all(addresses.map(x => this._updateAccount(x, accounts[x], currentLedgerState)));
      }
    } catch (error) {} finally {
      releaseLock();
    }
  }
  async getAvailableBalance(address, currentLedgerState) {
    try {
      const result = await this.xrplJRPC.getAccountInfo(address, currentLedgerState === null || currentLedgerState === void 0 ? void 0 : currentLedgerState.ledger_index);
      const {
        Balance,
        OwnerCount
      } = result.account_data;
      const {
        baseReserve,
        ownerReserve
      } = this.ledgerTracker.getNetworkReserve();
      let availableBalance = new BigNumber(Balance);
      const balance = new BigNumber(Balance);
      const reservedBalance = OwnerCount * ownerReserve + baseReserve;
      if (balance.isZero()) {
        availableBalance = new BigNumber(0);
      } else {
        availableBalance = balance.dividedBy(1000000.0).minus(reservedBalance).decimalPlaces(8);
        if (availableBalance.lt(0)) {
          availableBalance = new BigNumber(0);
        }
      }
      return {
        availableBalance,
        reservedBalance: new BigNumber(reservedBalance).multipliedBy(1000000.0).decimalPlaces(0)
      };
    } catch (error) {
      if (error.message.includes("actNotFound")) {
        return {
          availableBalance: new BigNumber(0),
          reservedBalance: new BigNumber(0)
        };
      }
      throw error;
    }
  }
  async getFilteredAccountLine(account, peer) {
    peer.currency = parseCurrencyToReadableFormat(peer.currency);
    const result = await this.xrplJRPC.getAccountLines({
      account,
      peer: peer.issuer
    });
    const {
      lines
    } = result;
    const filteredLines = lines.filter(line => {
      return line.currency === peer.currency;
    });
    if (filteredLines.length === 0) {
      return undefined;
    }
    return filteredLines[0];
  }
  async checkIsAccountActivated(address, currentLedgerState) {
    try {
      await this.xrplJRPC.getAccountInfo(address, currentLedgerState === null || currentLedgerState === void 0 ? void 0 : currentLedgerState.ledger_index);
      return true;
    } catch (error) {
      if (error.message.includes("actNotFound")) {
        return false;
      }
      throw error;
    }
  }
  async _updateAccount(address, accountInfo, currentLedgerState) {
    const currentChainId = this.getCurrentChainId();
    if (currentChainId === "loading") {
      return;
    }
    const {
      availableBalance,
      reservedBalance
    } = await this.getAvailableBalance(address, currentLedgerState);
    const accountData = _objectSpread(_objectSpread({}, accountInfo), {}, {
      reservedBalance: reservedBalance.toString(),
      balance: availableBalance.toString()
    });
    // update accounts state
    const {
      accounts: newAccounts
    } = this.state;
    // only populate if the entry is still present
    if (!newAccounts[address]) return;
    newAccounts[address] = accountData;
    this.update({
      accounts: newAccounts
    });
  }
}

class ChainConfigController extends BaseController {
  constructor(_ref) {
    let {
      state,
      config
    } = _ref;
    super({
      state,
      config
    });
    this.defaultState = _objectSpread({
      chainCfgNetworkLoadingState: LoadingState.FULL_RELOAD,
      availableNetworks: state && state.availableNetworks.length > 3 ? state.availableNetworks : DEFAULT_XRPL_CHAIN_NETWORK_KEYS,
      chainNetworks: state && state.chainNetworks.length > 3 ? state.chainNetworks : DEFAULT_XRPL_CHAIN_CONFIGS
    }, state);
    this.defaultConfig = _objectSpread({}, config);
    this.initialize();
  }
  async refreshChainNetworks(refreshParams) {
    const {
      jwt
    } = refreshParams;
    let networkKeys;
    let xrplChainNetworks;
    try {
      xrplChainNetworks = await this.getXRPLNetworksList(jwt);
      networkKeys = this.getAvailableChainNetworkKeys(xrplChainNetworks);
      this.update({
        chainCfgNetworkLoadingState: LoadingState.LOADED,
        availableNetworks: networkKeys,
        chainNetworks: xrplChainNetworks
      });
    } catch (err) {
      log.error(`[Error] Refresh chain networks: ${err}`);
      this.update({
        chainCfgNetworkLoadingState: LoadingState.LOADED,
        availableNetworks: DEFAULT_XRPL_CHAIN_NETWORK_KEYS,
        chainNetworks: DEFAULT_XRPL_CHAIN_CONFIGS
      });
    }
  }

  // crate new user defined network
  async createChainNetwork(chainNetwork, params) {
    await this.createNewXRPLNetworkConfig(chainNetwork, params.jwt);
    await this.refreshChainNetworks({
      jwt: params.jwt
    });
  }

  // update user defined chain network
  async updateChainNetwork(chainNetworkToUpdate, params) {
    await this.updateXRPLNetworkConfig(chainNetworkToUpdate, params.jwt);
    await this.refreshChainNetworks({
      jwt: params.jwt
    });
  }

  // delete user defined chain network
  async deleteChainNetwork(chainId, params) {
    await this.deleteXRPLNetworkConfig(chainId, params.jwt);
    await this.refreshChainNetworks({
      jwt: params.jwt
    });
  }
  getXrplChainConfig(network) {
    const chain = this.state.chainNetworks.find(c => c.networkKey === network);
    if (chain) {
      return chain;
    }
    throw new Error(`Unsupported xrpl network: ${network}`);
  }
  mapChaindIdToNetwork(chainId) {
    const chainCfg = this.state.chainNetworks.find(c => c.chainId === chainId);
    if (!chainCfg) {
      throw new Error(`No network found with chain id: ${chainId}`);
    }
    return chainCfg;
  }
  async getXRPLNetworksList(jwt) {
    const resp = await get(`${this.config.api}/networks`, {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: `Bearer ${jwt}`
      }
    });
    if (!resp.data) {
      throw new Error(`Failed to fetch xrpl chain confgs::${resp.message}`);
    }
    const chainList = resp.data;
    this.update({
      chainNetworks: chainList
    });
    return chainList;
  }
  async createNewXRPLNetworkConfig(xrplChainCfg, jwt) {
    try {
      await post(`${this.config.api}/networks`, xrplChainCfg, {
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          Authorization: `Bearer ${jwt}`
        }
      });
    } catch (err) {
      const error = err;
      const errMessage = error.status && error.statusText ? `${error.status}, ${error.statusText}` : error;
      throw new Error(`Failed to create xrpl config::${errMessage}`);
    }
  }
  async updateXRPLNetworkConfig(xrplChainCfg, jwt) {
    try {
      await patch(`${this.config.api}/networks/${xrplChainCfg.chainId}`, xrplChainCfg, {
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          Authorization: `Bearer ${jwt}`
        }
      });
    } catch (err) {
      const error = err;
      const errMessage = error.status && error.statusText ? `${error.status},${error.statusText}` : error;
      throw new Error(`Failed to update xrpl config::${errMessage}`);
    }
  }
  async deleteXRPLNetworkConfig(chainId, jwt) {
    try {
      await remove(`${this.config.api}/networks/${chainId}`, {}, {
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          Authorization: `Bearer ${jwt}`
        }
      });
    } catch (err) {
      const error = err;
      const errMessage = error.status && error.statusText ? `${error.status},${error.statusText}` : error;
      throw new Error(`Failed to delete xrpl config::${errMessage}`);
    }
  }
  getAvailableChainNetworkKeys(chainNetworks) {
    return chainNetworks.map(chain => chain.networkKey);
  }
}

class CurrencyController extends BaseCurrencyController {
  constructor(_ref) {
    let {
      config,
      state = {}
    } = _ref;
    super({
      config,
      state
    });
    _defineProperty(this, "conversionInterval", void 0);
    this.update({
      usdConversionRate: 0
    });
  }

  /**
   * Updates the conversionRate and conversionDate properties associated with the currentCurrency. Updated info is
   * fetched from an external API
   *
   */
  async updateConversionRate() {
    let currentCurrency;
    let nativeCurrency;
    try {
      // fiat
      currentCurrency = this.getCurrentCurrency();
      const usd = "USD";

      // crypto
      nativeCurrency = this.getNativeCurrency();
      const apiUrl = `${this.config.api}/currency?fsym=${nativeCurrency.toUpperCase()}&tsyms=${currentCurrency.toUpperCase()}`;
      const usdApiUrl = `${this.config.api}/currency?fsym=${nativeCurrency.toUpperCase()}&tsyms=${usd}`;
      const responsePromises = [];
      let responses = [];
      try {
        responsePromises.push(fetch(apiUrl));
        if (apiUrl !== usdApiUrl) {
          responsePromises.push(fetch(usdApiUrl));
        }
        responses = await Promise.all(responsePromises);
      } catch (error) {
        log.error(error, "CurrencyController - Failed to request currency from cryptocompare");
        return;
      }
      // parse response
      let parsedResponses;
      try {
        parsedResponses = await Promise.all(responses.map(response => response.json()));
      } catch {
        log.error(new Error(`CurrencyController - Failed to parse response "${responses.map(response => response.status)}"`));
        return;
      }
      if (parsedResponses[0][currentCurrency.toUpperCase()]) {
        const rate = Number(parsedResponses[0][currentCurrency.toUpperCase()]);
        this.setConversionRate(rate);
        this.setConversionDate((Date.now() / 1000).toString());
        this.update({
          usdConversionRate: parsedResponses[1] ? parsedResponses[1][usd] : rate
        });
      } else {
        this.setConversionRate(0);
        this.setConversionDate("N/A");
        this.update({
          usdConversionRate: 0
        });
      }
    } catch (error) {
      // reset current conversion rate
      log.warn("Torus - Failed to query currency conversion:", nativeCurrency, currentCurrency, error);
      this.setConversionRate(0);
      this.setConversionDate("N/A");
      this.update({
        usdConversionRate: 0
      });
      // throw error
      log.error(error, `CurrencyController - Failed to query rate for currency "${currentCurrency}"`);
    }
  }
  scheduleConversionInterval() {
    if (this.conversionInterval) {
      window.clearInterval(this.conversionInterval);
    }
    this.conversionInterval = window.setInterval(() => {
      this.updateConversionRate();
    }, this.config.pollInterval);
  }
}

class KeyringController extends BaseKeyringController {
  constructor(_ref) {
    let {
      config = {},
      state
    } = _ref;
    super({
      config,
      state
    });
    _defineProperty(this, "name", "KeyringController");
  }
  getAccounts() {
    return this.state.wallets.map(x => x.address);
  }
  getPublicKeys() {
    return this.state.wallets.map(x => x.publicKey);
  }
  getPublicKeyFromAddress(address) {
    const keyPair = this.state.wallets.find(x => x.address === address);
    if (!keyPair) throw new Error("key does not exist");
    return keyPair.publicKey;
  }
  importAccountFromSecret(secret) {
    const wallet = Wallet.fromSecret(secret, {
      algorithm: ECDSA.secp256k1
    }); // web3auth network currently only supports the secp256k1 key
    const existingWallet = this.state.wallets.find(x => x.privateKey.toLowerCase() === wallet.privateKey.toLowerCase());
    if (existingWallet) return existingWallet.address;
    this.update({
      wallets: [...this.state.wallets, {
        publicKey: wallet.publicKey,
        privateKey: wallet.privateKey,
        address: wallet.address
      }]
    });
    return wallet.address;
  }
  importAccount(privateKey) {
    const seed = generateSeed({
      entropy: Buffer.from(privateKey.padStart(64, "0"), "hex"),
      algorithm: "ecdsa-secp256k1"
    });
    return this.importAccountFromSecret(seed);
  }
  removeAccount(address) {
    const existingWallets = [...this.state.wallets];
    const index = this.state.wallets.findIndex(x => x.address === address);
    if (index !== -1) {
      existingWallets.splice(index, 1);
      this.update({
        wallets: existingWallets
      });
    }
  }
  signTransaction(txn, address, txOptions) {
    const keyring = this.state.wallets.find(x => x.address === address);
    if (!keyring) {
      throw new Error("key does not exist");
    }
    const wallet = new Wallet(keyring.publicKey, keyring.privateKey);
    const signedTx = wallet.sign(txn, !!(txOptions !== null && txOptions !== void 0 && txOptions.multisign));
    return signedTx;
  }
  signMessage(message, address) {
    const keyring = this.state.wallets.find(x => x.address === address);
    if (!keyring) {
      throw new Error("key does not exist");
    }
    const hashedMessage = hashMessage(message).toString("hex");
    const signedMessage = sign(hashedMessage, keyring.privateKey);
    return signedMessage;
  }
  async signAuthMessage(address, message) {
    const keyring = this.state.wallets.find(x => x.address === address);
    if (!keyring) {
      throw new Error("key does not exist");
    }
    const hashedMessage = hashMessage(message).toString("hex");
    const rawMessageSig = sign(hashedMessage, keyring.privateKey);
    return Promise.resolve(rawMessageSig);
  }
}

const sec$1 = 1000;
const calculateSum = (accumulator, currentValue) => accumulator + currentValue;
const ledgerTrackerEvents = ["sync", "latest"];
class BaseLedgerTracker extends BaseController {
  constructor(_ref) {
    let {
      config = {},
      state = {}
    } = _ref;
    super({
      config,
      state
    });

    // config
    _defineProperty(this, "name", "BaseLedgerTracker");
    _defineProperty(this, "_ledgerResetTimeout", void 0);
    this.defaultState = {
      _currentLedgerState: {
        idempotencyKey: ""
      },
      _isRunning: false
    };
    this.defaultConfig = {
      ledgerResetDuration: 20 * sec$1
    };
    this.initialize();

    // bind functions for internal use
    this._onNewListener = this._onNewListener.bind(this);
    this._onRemoveListener = this._onRemoveListener.bind(this);
    this._resetCurrentLedger = this._resetCurrentLedger.bind(this);

    // listen for handler changes
    this._setupInternalEvents();
  }
  isRunning() {
    return this.state._isRunning;
  }
  getCurrentLedgerState() {
    return this.state._currentLedgerState;
  }
  async getLatestLedgerState() {
    // return if available
    if (this.state._currentLedgerState) {
      return this.state._currentLedgerState;
    }
    // wait for a new latest ledger state
    const latestLedgerState = await new Promise(resolve => {
      this.once("latest", newState => {
        if (newState._currentLedgerState) {
          resolve(newState._currentLedgerState);
        }
      });
    });
    // return newly set current ledger state
    return latestLedgerState;
  }

  // dont allow module consumer to remove our internal event listeners
  removeAllListeners(eventName) {
    if (eventName) {
      super.removeAllListeners(eventName);
    } else {
      super.removeAllListeners();
    }
    // re-add internal events
    this._setupInternalEvents();
    // trigger stop check just in case
    this._onRemoveListener();
    return this;
  }

  /**
   * To be implemented in subclass.
   */
  _start() {
    // default behavior is noop
  }

  /**
   * To be implemented in subclass.
   */
  _end() {
    // default behavior is noop
  }
  _newPotentialLatest(newLedgerState) {
    const currentLedgerState = this.state._currentLedgerState;
    // only update if blok number is higher
    if (currentLedgerState && newLedgerState.idempotencyKey === currentLedgerState.idempotencyKey) {
      return;
    }
    this._setCurrentLedgerState(newLedgerState);
  }
  _setupInternalEvents() {
    // first remove listeners for idempotency
    this.removeListener("newListener", this._onNewListener);
    this.removeListener("removeListener", this._onRemoveListener);
    // then add them
    this.on("removeListener", this._onRemoveListener);
    this.on("newListener", this._onNewListener);
  }
  _onNewListener() {
    this._maybeStart();
  }
  _onRemoveListener() {
    // `removeListener` is called *after* the listener is removed
    if (this._getLedgerTrackerEventCount() > 0) {
      return;
    }
    this._maybeEnd();
  }
  _maybeStart() {
    if (this.state._isRunning) {
      return;
    }
    this.state._isRunning = true;
    // cancel setting latest ledger to stale
    this._cancelLedgerResetTimeout();
    this._start();
  }
  _maybeEnd() {
    if (!this.state._isRunning) {
      return;
    }
    this.state._isRunning = false;
    this._setupLedgerResetTimeout();
    this._end();
  }
  _getLedgerTrackerEventCount() {
    return ledgerTrackerEvents.map(eventName => this.listenerCount(eventName)).reduce(calculateSum);
  }
  _setCurrentLedgerState(newLedgerState) {
    const oldLedgerState = this.state._currentLedgerState;
    this.update({
      _currentLedgerState: newLedgerState
    });
    this.emit("latest", newLedgerState);
    this.emit("sync", {
      oldLedgerState,
      newLedgerState
    });
  }
  _setupLedgerResetTimeout() {
    // clear any existing timeout
    this._cancelLedgerResetTimeout();
    // clear latest ledger when stale
    this._ledgerResetTimeout = setTimeout(this._resetCurrentLedger, this.config.ledgerResetDuration);

    // nodejs - dont hold process open
    if (this._ledgerResetTimeout.unref) {
      this._ledgerResetTimeout.unref();
    }
  }
  _cancelLedgerResetTimeout() {
    if (this._ledgerResetTimeout) {
      clearTimeout(this._ledgerResetTimeout);
    }
  }
  _resetCurrentLedger() {
    this.update({
      _currentLedgerState: {
        idempotencyKey: ""
      }
    });
  }
}

const sec = 1000;
class PollingLedgerTracker extends BaseLedgerTracker {
  constructor(_ref) {
    let {
      config,
      state = {}
    } = _ref;
    // parse + validate args
    if (!config.provider) {
      throw new Error("PollingLedgerTracker - no provider specified.");
    }
    super({
      config,
      state
    });

    // config
    _defineProperty(this, "xrplJRPC", void 0);
    /**
     * get ledger fee info
     */
    _defineProperty(this, "getLedgerFee", () => {
      return this.xrplJRPC.getLedgerFee();
    });
    // source: https://github.dev/XRPLF/xrpl-py/tree/master/xrpl/asyncio
    // https://gist.github.com/WietseWind/3e9f9339f37a5881978a9661f49b0e52
    _defineProperty(this, "getAvailableNetworkFee", async () => {
      try {
        const feeDataSet = await this.getLedgerFee();

        // set the suggested fee base on queue percentage
        const {
          current_queue_size: currentQueueSize,
          max_queue_size: maxQueueSize,
          drops
        } = feeDataSet;

        // check what percentage of transaction queue is full
        const queuePercentage = new BigNumber(currentQueueSize).dividedBy(maxQueueSize);

        // if queue is full then suggest highest fee, if queue is empty thn suggest lowest fee other wise
        // suggest medium fee.
        const suggestedFee = queuePercentage.isEqualTo(1) ? "feeHigh" : queuePercentage.isEqualTo(0) ? "feeLow" : "feeMedium";

        // set the drops values to BigNumber instance
        // The multiplier 1.5 is choosen to calculate a bit higher fee thn minimum fee
        // to accomodate the network conditions.
        const minimumFee = new BigNumber(drops.minimum_fee).multipliedBy(1.5).integerValue(BigNumber.ROUND_HALF_FLOOR);
        const medianFee = new BigNumber(drops.median_fee);

        // open ledger fee is the fee required to included tx directly in ledger
        // without waiting in queue.
        const openLedgerFee = new BigNumber(drops.open_ledger_fee);

        // calculate lowest fee
        const feeLow = BigNumber.minimum(BigNumber.maximum(minimumFee, BigNumber.maximum(medianFee, openLedgerFee).dividedBy(500)).integerValue(BigNumber.ROUND_HALF_CEIL), new BigNumber(1000)).toString();

        // cap the medium fee to 0.01 xrp
        // if queue is more than 10 percent full thn take the average of min, median and open ledger fee
        // and cap it to 0.01 xrp
        const feeMedium = BigNumber.minimum(queuePercentage.isGreaterThan(0.1) ? minimumFee.plus(medianFee).plus(openLedgerFee).dividedBy(3).integerValue(BigNumber.ROUND_HALF_CEIL) : queuePercentage.isEqualTo(0) ? BigNumber.maximum(minimumFee.multipliedBy(10), BigNumber.minimum(minimumFee, openLedgerFee)) : BigNumber.maximum(minimumFee.multipliedBy(10), minimumFee.plus(medianFee).dividedBy(2).integerValue(BigNumber.ROUND_HALF_CEIL)), new BigNumber(feeLow).multipliedBy(15), new BigNumber(10000)).toString();

        // cap the highest fee to 0.1 xrp
        const feeHigh = BigNumber.minimum(BigNumber.maximum(minimumFee.multipliedBy(10), BigNumber.maximum(medianFee, openLedgerFee).multipliedBy(1.1).integerValue(BigNumber.ROUND_HALF_CEIL)), new BigNumber(100000)).toString();
        return {
          availableFees: [{
            type: "low",
            value: feeLow,
            suggested: suggestedFee === "feeLow"
          }, {
            type: "medium",
            value: feeMedium,
            suggested: suggestedFee === "feeMedium"
          }, {
            type: "high",
            value: feeHigh,
            suggested: suggestedFee === "feeHigh"
          }]
        };
      } catch (e) {
        log.warn("Unable to calculate available network fees:", e);
        throw new Error("Unable to calculate available network fees!");
      }
    });
    _defineProperty(this, "getNetworkReserve", () => {
      const {
        baseReserve,
        ownerReserve
      } = this.config;
      return {
        baseReserve,
        ownerReserve
      };
    });
    this.defaultConfig = {
      provider: config.provider,
      pollingInterval: 20 * sec,
      retryTimeout: 2 * sec,
      setSkipCacheFlag: false,
      ownerReserve: 2,
      baseReserve: 10
    };
    this.xrplJRPC = new XrplJrpcService(config.provider);
    this.initialize();
  }
  get lastValidatedLedgerIndex() {
    return get$1(this.state, "_currentLedgerState.result.ledger_index", 0);
  }
  get lastClosedLedgerIndex() {
    return get$1(this.state, "_currentLedgerState.closed_ledger_index", 0);
  }
  async getLastClosedLedger() {
    return this.xrplJRPC.getLatestLedgerState("closed");
  }
  // trigger ledger polling
  async checkForLatestLedgerState() {
    await this._updateLatestLedger();
    return this.getLatestLedgerState();
  }
  _start() {
    this._synchronize().catch(err => this.emit("error", err));
  }
  async _synchronize() {
    while (this.state._isRunning) {
      try {
        await this._updateLatestLedger();
        await timeout(this.config.pollingInterval);
      } catch (err) {
        const newErr = new Error(`PollingLedgerTracker - encountered an error while attempting to update latest ledger state:\n${err.stack}`);
        try {
          this.emit("error", newErr);
        } catch (emitErr) {
          log.error(newErr);
        }
        await timeout(this.config.retryTimeout);
      }
    }
  }
  async _updateLatestLedger() {
    // fetch + set latest ledger state
    const latestLedgerState = await this._fetchLatestLedger();
    this._newPotentialLatest(latestLedgerState);
  }
  async _fetchLatestLedger() {
    try {
      const [validatedLedgerResponse, closedLedgerResponse] = await Promise.all([this.xrplJRPC.getLatestLedgerState(), this.xrplJRPC.getLatestLedgerState("closed")]);
      const result = validatedLedgerResponse;
      // only return if ledger state is final
      if (result.validated) {
        return _objectSpread({
          idempotencyKey: result.ledger_hash,
          closed_ledger_index: closedLedgerResponse === null || closedLedgerResponse === void 0 ? void 0 : closedLedgerResponse.ledger_index
        }, validatedLedgerResponse);
      }
    } catch (error) {
      throw new Error(`PollingLedgerTracker - encountered error fetching ledger state:\n${error}`);
    }
  }
}

class MessageManager extends BaseController {
  /**
   * Controller in charge of managing - storing, adding, removing, updating - Messages.
   *
   */
  constructor(_ref) {
    let {
      config,
      state,
      signMessage
    } = _ref;
    super({
      config,
      state
    });
    _defineProperty(this, "_signMessage", void 0);
    this.defaultState = {
      unapprovedMsgs: {},
      unapprovedMsgCount: 0,
      messages: []
    };
    this.defaultConfig = {};
    this._signMessage = signMessage;
    super.initialize();
  }
  get unapprovedMsgCount() {
    return Object.keys(this.getUnapprovedMessages()).length;
  }
  async addUnapprovedMessage(message, from, req) {
    const messageParams = {
      id: randomId(),
      from,
      time: Date.now(),
      status: MessageStatus.UNAPPROVED,
      messageString: message
    };
    const result = new Promise((resolve, reject) => {
      if (req !== null && req !== void 0 && req.origin) messageParams.origin = origin;
      this.addMsg(messageParams);
      this.emit(MESSAGE_EVENTS.UNAPPROVED_MSG, {
        messageParams,
        req
      });

      // await finished
      this.once(`${messageParams.id}:finished`, data => {
        switch (data.status) {
          case MessageStatus.SIGNED:
            return resolve(data.signature);
          case MessageStatus.REJECTED:
            return reject(new Error("Torus Message Signature: User denied message signature."));
          default:
            return reject(new Error(`Torus Message Signature: Unknown problem: ${JSON.stringify(messageParams)}`));
        }
      });
    });
    return {
      result,
      message: messageParams
    };
  }
  rejectMsg(messageId) {
    this._setMsgStatus(messageId, MessageStatus.REJECTED);
  }
  signMessage(messageId) {
    const message = this.getMsg(messageId);
    const signature = this._signMessage(message.messageString, message.from);
    message.signature = signature;
    this._updateMsg(message);
    this._setMsgStatus(messageId, MessageStatus.SIGNED);
    return signature;
  }
  addMsg(message) {
    this.update({
      messages: [...this.state.messages, message]
    });
    this._saveMsgList();
  }
  getMsg(messageId) {
    return this.state.messages.find(message => message.id === messageId);
  }
  _setMsgStatus(messageId, status) {
    const message = this.getMsg(messageId);
    if (!message) throw new Error(`MessageManager - Message not found for id: "${messageId}".`);
    message.status = status;
    this._updateMsg(message);
    this.emit(`${messageId}:${status}`, message);
    if (status === MessageStatus.REJECTED || status === MessageStatus.SIGNED) {
      this.emit(`${messageId}:finished`, message);
    }
  }
  _updateMsg(message_) {
    const index = this.state.messages.findIndex(message => message.id === message_.id);
    if (index !== -1) {
      this.state.messages[index] = message_;
    }
    this._saveMsgList();
  }
  getUnapprovedMessages() {
    return this.state.messages.filter(message => message.status === MessageStatus.UNAPPROVED).reduce((result, message) => {
      result[message.id] = message;
      return result;
    }, {});
  }
  _saveMsgList() {
    const unapprovedMsgs = this.getUnapprovedMessages();
    const unapprovedMessageCount = Object.keys(unapprovedMsgs).length;
    this.update({
      unapprovedMsgs,
      unapprovedMsgCount: unapprovedMessageCount
    });
  }
}

const RPC_METHODS = {
  GET_ACCOUNTS: "xrpl_getAccounts",
  GET_KEY_PAIR: "xrpl_getKeyPair",
  GET_PUBLIC_KEY: "xrpl_getPublicKey",
  SIGN_MESSAGE: "xrpl_signMessage",
  SIGN_TRANSACTION: "xrpl_signTransaction",
  SUBMIT_TRANSACTION: "xrpl_submitTransaction",
  ADD_CHAIN: "xrpl_addChain",
  SWITCH_CHAIN: "xrpl_switchChain",
  CHAIN_ID: "xrpl_chainId",
  PROVIDER_CHAIN_CONFIG: "xrpl_providerChainConfig"
};
function createGetAccountsMiddleware(_ref) {
  let {
    getAccounts
  } = _ref;
  return createAsyncMiddleware(async (request, response, next) => {
    const {
      method
    } = request;

    // hack to override big ids from fetch middleware which are not supported in xrpl servers
    // TODO: fix this for xrpl controllers.
    request.id = randomId();
    if (method !== RPC_METHODS.GET_ACCOUNTS) return next();
    if (!getAccounts) throw new Error("WalletMiddleware - opts.getAccounts not provided");
    // This calls from the prefs controller
    const accounts = await getAccounts(request);
    response.result = accounts;
    return undefined;
  });
}
function createGenericJRPCMiddleware(targetMethod, handler) {
  return createAsyncMiddleware(async (request, response, next) => {
    const {
      method
    } = request;
    if (method !== targetMethod) return next();
    if (!handler) throw new Error(`WalletMiddleware - ${targetMethod} not provided`);
    const result = await handler(request);
    response.result = result;
    return undefined;
  });
}
function createXRPLMiddleware(providerHandlers) {
  const {
    version,
    getAccounts,
    submitTransaction,
    signTransaction,
    signMessage,
    getProviderState
  } = providerHandlers;
  return mergeMiddleware([createScaffoldMiddleware({
    version,
    [PROVIDER_JRPC_METHODS.GET_PROVIDER_STATE]: getProviderState
  }), createGetAccountsMiddleware({
    getAccounts
  }), createGenericJRPCMiddleware(RPC_METHODS.SIGN_TRANSACTION,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  signTransaction), createGenericJRPCMiddleware(RPC_METHODS.SUBMIT_TRANSACTION,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submitTransaction),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createGenericJRPCMiddleware(RPC_METHODS.SIGN_MESSAGE, signMessage)]);
}

function createChainIdMiddleware(chainId) {
  return (req, res, next, end) => {
    if (req.method === RPC_METHODS.CHAIN_ID) {
      res.result = chainId;
      return end();
    }
    return next();
  };
}
function createProviderConfigMiddleware(providerConfig) {
  return (req, res, next, end) => {
    if (req.method === RPC_METHODS.PROVIDER_CHAIN_CONFIG) {
      res.result = providerConfig;
      return end();
    }
    return next();
  };
}
function createJsonRpcClient(providerConfig, networkConfig) {
  const {
    chainId,
    rpcTarget
  } = providerConfig;
  const fetchMiddleware = createFetchMiddleware({
    rpcTarget
  });
  const ledgerProvider = providerFromMiddleware(fetchMiddleware);
  const ledgerTracker = new PollingLedgerTracker({
    config: _objectSpread(_objectSpread({}, networkConfig), {}, {
      provider: ledgerProvider
    }),
    state: {}
  });
  const networkMiddleware = mergeMiddleware([createChainIdMiddleware(chainId), createProviderConfigMiddleware(providerConfig), fetchMiddleware]);
  return {
    networkMiddleware,
    ledgerTracker
  };
}

const _excluded = ["chainId", "rpcTarget"];

// use state_get_balance for account balance

class NetworkController extends BaseController {
  constructor(_ref) {
    let {
      config,
      state
    } = _ref;
    super({
      config,
      state
    });
    _defineProperty(this, "name", "NetworkController");
    _defineProperty(this, "_providerProxy", void 0);
    _defineProperty(this, "_ledgerTrackerProxy", void 0);
    _defineProperty(this, "mutex", new Mutex());
    _defineProperty(this, "_provider", null);
    _defineProperty(this, "xrplJRPC", void 0);
    _defineProperty(this, "_baseProviderHandlers", void 0);
    const providerConfig = DEFAULT_XRPL_CHAIN_CONFIGS.find(cfg => cfg.networkKey === "mainnet");
    this.defaultState = {
      chainId: "loading",
      properties: {},
      providerConfig
    };
    this.initialize();
  }
  getNetworkIdentifier() {
    return this.state.chainId;
  }

  /**
   * Called by orchestrator once while initializing the class
   * @param providerHandlers - JRPC handlers for provider
   * @returns - provider - Returns the providerProxy
   */
  initializeProvider(providerHandlers) {
    this._baseProviderHandlers = providerHandlers;
    this.configureProvider();
    this.lookupNetwork(); // Not awaiting this, because we don't want to block the initialization
    return this._providerProxy;
  }
  getProvider() {
    return this._providerProxy;
  }
  setProviderConfig(config) {
    this.update({
      providerConfig: _objectSpread({}, config)
    });
    this.refreshNetwork();
  }
  getProviderConfig() {
    return this.state.providerConfig;
  }

  /**
   * Refreshes the current network code
   */
  async lookupNetwork() {
    const {
      rpcTarget,
      chainId
    } = this.getProviderConfig();
    console.log("chain config", rpcTarget, chainId);
    if (!chainId || !rpcTarget) {
      this.update({
        chainId: "loading",
        properties: {}
      });
      return;
    }
    if (!this.xrplJRPC) {
      this.xrplJRPC = new XrplJrpcService(rpcTarget);
    }
    console.log("aquiring lock");
    const releaseLock = await this.mutex.acquire();
    console.log("aquired lock");
    try {
      const result = await this.xrplJRPC.ping();
      console.log("ping response", result);
      if ((result === null || result === void 0 ? void 0 : result.status) !== "success") {
        throw new Error(`Failed to ping network for given rpc target: ${rpcTarget}`);
      }
      this.update({
        chainId
      });
      this.emit("networkDidChange");
    } catch (err) {
      console.log("Error while connecting", err);
      log.error("Error while connecting", err);
      this.update({
        chainId: "loading"
      });
    } finally {
      releaseLock();
    }
  }
  configureProvider() {
    const _this$getProviderConf = this.getProviderConfig(),
      {
        chainId,
        rpcTarget
      } = _this$getProviderConf,
      rest = _objectWithoutProperties(_this$getProviderConf, _excluded);
    if (!chainId || !rpcTarget) {
      throw new Error("chainId and rpcTarget must be provider in providerConfig");
    }
    this.configureStandardProvider(_objectSpread({
      chainId,
      rpcTarget
    }, rest));
  }
  configureStandardProvider(providerConfig) {
    const networkClient = createJsonRpcClient(providerConfig, this.config);
    this.setNetworkClient(networkClient);
  }
  setNetworkClient(_ref2) {
    let {
      networkMiddleware,
      ledgerTracker
    } = _ref2;
    const xrplMiddleware = createXRPLMiddleware(this._baseProviderHandlers);
    const engine = new JRPCEngine();
    engine.push(xrplMiddleware);
    engine.push(networkMiddleware);
    const provider = providerFromEngine(engine);
    this.setProvider({
      provider,
      ledgerTracker
    });
  }
  setProvider(_ref3) {
    let {
      provider,
      ledgerTracker
    } = _ref3;
    if (this._providerProxy) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this._providerProxy.setTarget(provider);
    } else {
      this._providerProxy = createSwappableProxy(provider);
    }
    if (this._ledgerTrackerProxy) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this._ledgerTrackerProxy.setTarget(ledgerTracker);
    } else {
      this._ledgerTrackerProxy = createEventEmitterProxy(ledgerTracker, {
        eventFilter: "skipInternal"
      });
    }
    // set new provider and blockTracker
    this._provider = provider;
    this._provider.setMaxListeners(10);
  }
  refreshNetwork() {
    this.update({
      chainId: "loading",
      properties: {}
    });
    this.configureProvider();
    this.lookupNetwork();
  }
}

const getIpfsEndpoint = path => `https://infura-ipfs.io/ipfs/${path}`;
function sanitizeNftMetdataUrl(url) {
  let finalUri = url;
  if (url.startsWith("ipfs")) {
    const ipfsPath = url.split("ipfs://")[1];
    finalUri = getIpfsEndpoint(ipfsPath);
  }
  return finalUri;
}
async function validateImageUrl(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    if (img.complete) {
      resolve(true);
    } else {
      img.addEventListener("load", () => {
        resolve(true);
      });
      img.addEventListener("error", () => {
        reject(new Error("Failed to load image"));
      });
    }
  });
}
class NftsTrackerController extends BaseController {
  constructor(_ref) {
    let {
      state,
      config,
      getIdentities,
      getNfts,
      getNftOffers,
      getJwt
    } = _ref;
    super({
      config,
      state
    });
    _defineProperty(this, "getIdentities", void 0);
    _defineProperty(this, "getNfts", void 0);
    _defineProperty(this, "getNftOffers", void 0);
    _defineProperty(this, "getJwt", void 0);
    _defineProperty(this, "mutex", new Mutex());
    _defineProperty(this, "handle", void 0);
    this.defaultState = _objectSpread(_objectSpread({}, state), {}, {
      nfts: {},
      nftOffers: {}
    });
    this.defaultConfig = _objectSpread({}, config);
    this.initialize();
    this.getIdentities = getIdentities;
    this.getNfts = getNfts;
    this.getNftOffers = getNftOffers;
    this.getJwt = getJwt;
  }
  async refreshNfts(uncachedAddress) {
    const addresses = Object.keys(this.getIdentities() || {});
    try {
      const fetchedNfts = await Promise.all(addresses.map(address => {
        const cached = uncachedAddress !== address;
        return Promise.all([this.getNfts(address, cached), this.getNftOffers(address, new URLSearchParams({
          offerStatus: "created",
          fetchProcessing: "1"
        }))]);
      }));
      fetchedNfts.forEach(async (_ref2, index) => {
        let [nftDetails, nftOffers] = _ref2;
        const sanitizedNfts = [];
        const nftDetailsWithNftMetadataUrl = await Promise.allSettled(nftDetails.map(async nft => {
          const sanitizedNftMetdataUrl = sanitizeNftMetdataUrl(nft.metadata.image);
          return validateImageUrl(sanitizedNftMetdataUrl).then(() => _objectSpread(_objectSpread({}, nft), {}, {
            sanitizedNftMetdataUrl
          }));
        }));
        nftDetailsWithNftMetadataUrl.forEach(async (result, nftIndex) => {
          const validatedImageUrl = result.status === "fulfilled";
          const nft = validatedImageUrl ? result.value : nftDetails[nftIndex];
          nft.metadata = _objectSpread(_objectSpread({}, nft.metadata), {}, {
            image: validatedImageUrl ? nft.sanitizedNftMetdataUrl : this.state.nftPlaceholderPath
          });
          sanitizedNfts.push(nft);
        });
        this.update({
          nfts: _objectSpread(_objectSpread({}, this.state.nfts), {}, {
            [addresses[index]]: sanitizedNfts
          }),
          nftOffers: _objectSpread(_objectSpread({}, this.state.nftOffers), {}, {
            [addresses[index]]: nftOffers
          })
        });
      });
      console.log("new state nfts", this.state.nfts);
    } catch (e) {
      log.error(e, `Error in resolving nfts for keys ${addresses.map(x => x.toString())}`);
    }
  }
  async getRecentAcceptedNftOffersByOthers(address) {
    if (!this.getJwt()) {
      return [];
    }
    const params = new URLSearchParams({
      fetchRecentAcceptedOffersByOthers: "1"
    });
    const nftOffers = await this.getNftOffers(address, params);
    return nftOffers;
  }
  async getNftById(address, nftId) {
    const nft = this.state.nfts[address].find(nftInfo => {
      if (nftInfo.nftokenID === nftId) return true;
      return false;
    });
    // todo: add method to fetch it from jrpc if not available in state.
    return nft;
  }
  async getNftOfferById(address, nftOfferId) {
    const isArray = Array.isArray(nftOfferId);
    const nftOfferIds = isArray ? nftOfferId : [nftOfferId];
    const offers = nftOfferIds.map(offerId => this.state.nftOffers[address].find(nftOffer => nftOffer.nftOfferIndex === offerId));
    // todo: add method to fetch it from jrpc if not available in state.
    return isArray ? offers : offers[0];
  }
  async poll() {
    const releaseLock = await this.mutex.acquire();
    if (this.handle) window.clearTimeout(this.handle);
    if (this.getJwt()) {
      // this should never throw
      await this.refreshNfts();
    }
    releaseLock();
    this.handle = window.setTimeout(() => {
      this.poll();
    }, this.config.interval || 180000);
  }
}

const getTxStatusFromJrpc = async (hash, provider, ledgerIndex) => {
  try {
    const xrplJRPC = new XrplJrpcService(provider);
    const {
      txValidated,
      txReceipt
    } = await xrplJRPC.getTransactionStatus(hash);
    log.info("pending tx found", txValidated);
    return getTxStatus({
      txValidated,
      hash,
      lastLedgerSequence: txReceipt.LastLedgerSequence,
      ledgerIndex,
      txResult: txReceipt.meta.TransactionResult
    });
  } catch (error) {
    log.warn("unable to fetch xrpl deploy", error);
    return undefined;
  }
};

/**
 * Controller that stores shared settings and exposes convenience methods
 */
class PreferencesController extends BasePreferencesController {
  /**
   * Creates a PreferencesController instance
   *
   * @param config - Initial options used to configure this controller
   * @param state - Initial state to set on this controller
   */
  constructor(_ref) {
    let {
      config,
      state,
      provider,
      signAuthMessage,
      getProviderConfig,
      chainCfgController,
      getCurrentCurrency,
      getConversionRate,
      getNativeCurrency,
      getLastLedgerState
    } = _ref;
    super({
      config,
      state,
      defaultPreferences: {
        formattedPastTransactions: [],
        fetchedPastTx: []
      },
      signAuthMessage
    });
    _defineProperty(this, "handle", void 0);
    _defineProperty(this, "mutex", new Mutex());
    _defineProperty(this, "getProviderConfig", void 0);
    _defineProperty(this, "chainCfgController", void 0);
    _defineProperty(this, "provider", void 0);
    _defineProperty(this, "getCurrentCurrency", void 0);
    _defineProperty(this, "getConversionRate", void 0);
    _defineProperty(this, "getNativeCurrency", void 0);
    _defineProperty(this, "getLastLedgerState", void 0);
    _defineProperty(this, "xrplJRPC", void 0);
    this.provider = provider;
    this.getProviderConfig = getProviderConfig;
    this.chainCfgController = chainCfgController;
    this.getCurrentCurrency = getCurrentCurrency;
    this.getConversionRate = getConversionRate;
    this.getNativeCurrency = getNativeCurrency;
    this.getLastLedgerState = getLastLedgerState;
    this.xrplJRPC = new XrplJrpcService(provider);
  }
  async poll(interval) {
    var _this$getAddressState;
    const releaseLock = await this.mutex.acquire();
    if (interval) this.configure({
      pollInterval: interval
    });
    if (this.handle) window.clearTimeout(this.handle);
    // call here
    const storeSelectedAddress = this.state.selectedAddress;
    if (!storeSelectedAddress) return;
    if (!((_this$getAddressState = this.getAddressState(storeSelectedAddress)) !== null && _this$getAddressState !== void 0 && _this$getAddressState.jwtToken)) return;
    // This should never throw
    await this.sync(storeSelectedAddress);
    releaseLock();
    this.handle = window.setTimeout(() => {
      this.poll(this.config.pollInterval);
    }, this.config.pollInterval);
  }
  async initPreferences(params) {
    const {
      pubKey,
      address,
      jwtToken,
      calledFromEmbed,
      userInfo,
      type,
      rehydrate,
      locale = "en-US"
    } = params;
    await super.init(address, userInfo, jwtToken, {
      public_key: pubKey
    }, type);

    // refresh xrpl chain network list
    const addrState = this.getAddressState(address);
    if (addrState && addrState !== null && addrState !== void 0 && addrState.jwtToken) {
      await this.chainCfgController.refreshChainNetworks({
        jwt: addrState.jwtToken
      });
    }
    const {
      aggregateVerifier,
      verifier,
      verifierId
    } = userInfo || {};
    const userExists = await this.sync(address);
    if (!userExists) {
      const accountState = this.getAddressState(address);
      await this.createUser({
        selectedCurrency: accountState.selectedCurrency,
        theme: accountState.theme,
        verifier: aggregateVerifier || verifier,
        verifierId,
        locale,
        address
      });
    }
    if (!rehydrate) await this.storeUserLogin({
      verifier: aggregateVerifier || verifier,
      verifierId,
      options: {
        calledFromEmbed,
        rehydrate
      },
      address
    });
  }
  async sync(address) {
    try {
      const xrplUser = await this.getUser(address);
      if (xrplUser) {
        const {
          default_currency: defaultCurrency,
          contacts,
          theme,
          locale,
          public_address: userPublicAddress,
          default_public_address: defaultPublicAddress
        } = xrplUser || {};

        // update latest data in state.
        this.updateState({
          contacts,
          theme,
          selectedCurrency: defaultCurrency,
          locale,
          defaultPublicAddress: defaultPublicAddress || userPublicAddress
        }, address);
      }
      await Promise.all([this.getWalletOrders(address), this.getTopUpOrders(address)]).then(async data => {
        const [walletTx, paymentTx] = data;
        const calculateTxPromises = [];
        if (walletTx.length) {
          calculateTxPromises.push(this.calculatePastTx(walletTx, address));
        }
        // eslint-disable-next-line promise/always-return
        if (paymentTx.length) {
          calculateTxPromises.push(this.calculatePaymentTx(paymentTx, address));
        }
        await Promise.all(calculateTxPromises);
      }).then(() => this.mergeXrplApiTxs(address)).catch(error => {
        log.error("unable to fetch wallet orders", error);
      });
      return true;
    } catch (error) {
      log.error(error);
      return false;
    }
  }
  async patchNewTx(tx, address, nftInfo) {
    const currencyData = {
      selectedCurrency: this.getCurrentCurrency(),
      conversionRate: this.getConversionRate(),
      networkNativeCurrency: this.getNativeCurrency()
    };
    const chainCfg = this.chainCfgController.mapChaindIdToNetwork(tx.chainId);
    const formattedTx = formatNewTransaction(tx, currencyData, address, chainCfg, nftInfo);
    const storedPastTx = this.getAddressState(address).formattedPastTransactions;
    const duplicateIndex = storedPastTx.findIndex(x => x.transactionHash === tx.transactionHash && x.chainId === tx.chainId);

    // post tx only if once its submitted, after that just keep it in local store.
    // txns will be synced with backend and local store using sync function
    // which is getting polled and also on initialization of pref controller.
    if (duplicateIndex === -1 && tx.status === TransactionStatus.submitted) {
      this.updateState({
        formattedPastTransactions: [formattedTx, ...this.getAddressState(address).formattedPastTransactions]
      }, address);
      const txToPersist = formatTxToSave(formattedTx);
      this.postPastTx(txToPersist, address);
    } else if (duplicateIndex !== -1) {
      this.updateTxStatus(address, tx.transactionHash, tx.status);
    }
  }
  recalculatePastTx(address) {
    // This triggers store update which calculates past Tx status for that network
    const selectedAddress = address || this.state.selectedAddress;
    const state = this.getAddressState(selectedAddress);
    if (!(state !== null && state !== void 0 && state.fetchedPastTx)) return;
    this.calculatePastTx(state.fetchedPastTx, selectedAddress);
  }
  async getNfts(address) {
    let cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    try {
      const network = this.getProviderConfig().networkKey;
      const response = await get(`${this.config.api}/nft?userAddress=${address}&network=${network}&cached=${cached}`, this.headers(address), {
        useAPIKey: true
      });
      return response.success ? response.data ? response.data : [] : [];
    } catch (error) {
      log.error("unable to get nfts", error);
      return [];
    }
  }
  async getNftOffers(address, params) {
    try {
      var _response$data;
      const response = await get(`${this.config.api}/nftOffer?${params.toString()}`, this.headers(address), {
        useAPIKey: true
      });
      if (!response.success) {
        return [];
      }
      return (_response$data = response.data) !== null && _response$data !== void 0 ? _response$data : [];
    } catch (error) {
      log.error("unable to get nft offers", error);
      return [];
    }
  }

  // create new user-defined custom XRP chain network
  async createXrpChainNetwork(customNetwork) {
    const selectedAddrState = this.getAddressState(this.state.selectedAddress);
    if (selectedAddrState.jwtToken) {
      await this.chainCfgController.createChainNetwork(customNetwork, {
        jwt: selectedAddrState.jwtToken
      });
    }
  }

  // update the existing user-defined custom XRP chain network
  async updateXrpChainNetwork(customNetworkToUpdate) {
    const selectedAddrState = this.getAddressState(this.state.selectedAddress);
    if (selectedAddrState.jwtToken) {
      await this.chainCfgController.updateChainNetwork(customNetworkToUpdate, {
        jwt: selectedAddrState.jwtToken
      });
    }
  }

  // delete existing inactive user-defined custom XRP chain network
  async deleteXrpChainNetwork(chainId) {
    const currentChainCfg = this.getProviderConfig();
    if (currentChainCfg.chainId !== chainId) {
      const selectedAddrState = this.getAddressState(this.state.selectedAddress);
      if (selectedAddrState.jwtToken) {
        await this.chainCfgController.deleteChainNetwork(chainId, {
          jwt: selectedAddrState.jwtToken
        });
      }
    } else {
      throw new Error(`Cannot delete active network, ${currentChainCfg.networkKey}`);
    }
  }
  updateTxStatus(address, txHash, status) {
    const updatedTxns = [];
    this.getAddressState(address).formattedPastTransactions.forEach(txn => {
      if (txn.transactionHash === txHash) {
        txn.status = status;
        txn.statusText = getTxStatusText(status);
      }
      updatedTxns.push(txn);
    });
    this.updateState({
      formattedPastTransactions: [...updatedTxns]
    }, address);
  }
  async calculatePastTx(txs, address) {
    const pastTxs = [];
    const pendingTxs = [];
    const lowerCaseSelectedAddress = address.toLowerCase();
    const network = this.getProviderConfig().networkKey;
    const chainCfg = this.chainCfgController.getXrplChainConfig(network);
    for (const x of txs) {
      var _x$from, _x$to;
      if (x.chain_id === chainCfg.chainId && (lowerCaseSelectedAddress === ((_x$from = x.from) === null || _x$from === void 0 ? void 0 : _x$from.toLowerCase()) || lowerCaseSelectedAddress === ((_x$to = x.to) === null || _x$to === void 0 ? void 0 : _x$to.toLowerCase()))) {
        if (x.status !== TransactionStatus.confirmed) {
          pendingTxs.push(x);
        } else {
          const finalObject = formatPastTx(x, lowerCaseSelectedAddress, chainCfg.blockExplorerUrl);
          pastTxs.push(finalObject);
        }
      }
    }
    const pendingTxPromises = pendingTxs.map(x => getTxStatusFromJrpc(x.transaction_hash, this.provider, this.getLastLedgerState().ledger_index).catch(error => log.error(error)));
    const resolvedTxStatuses = await Promise.all(pendingTxPromises);
    for (let i = 0; i < pendingTxs.length; i++) {
      const element = pendingTxs[i];
      const finalObject = formatPastTx(element, lowerCaseSelectedAddress, chainCfg.blockExplorerUrl);
      finalObject.status = resolvedTxStatuses[i] || TransactionStatus.submitted;
      pastTxs.push(finalObject);
      if (lowerCaseSelectedAddress === element.from.toLowerCase() && finalObject.status && finalObject.status !== element.status) {
        await this.patchPastTx({
          id: element.id.toString(),
          status: finalObject.status,
          updated_at: new Date().toISOString()
        }, address);
      }
    }
    let mergedTxs = this.getAddressState(address).formattedPastTransactions.concat(pastTxs);
    const txSet = new Set();
    mergedTxs = mergedTxs.filter(tx => {
      const identifier = `${tx.chainId},${tx.transactionHash}`;
      if (!txSet.has(identifier)) {
        txSet.add(identifier);
        return true;
      }
      return false;
    }).sort((a, b) => Date.parse(b.rawDate) - Date.parse(a.rawDate));
    this.updateState({
      formattedPastTransactions: [...mergedTxs]
    }, address);
  }
  calculatePaymentTx(txs, address) {
    const paymentTxs = [];
    for (const tx of txs) {
      let action = "";
      const lowerCaseAction = tx.action.toLowerCase();
      if (ACTIVITY_ACTION_TOPUP.includes(lowerCaseAction)) {
        action = ACTIVITY_ACTION_TOPUP;
      } else if (ACTIVITY_ACTION_SEND.includes(lowerCaseAction)) {
        action = ACTIVITY_ACTION_SEND;
      } else if (ACTIVITY_ACTION_RECEIVE.includes(lowerCaseAction)) {
        action = ACTIVITY_ACTION_RECEIVE;
      }
      paymentTxs.push(_objectSpread(_objectSpread({}, tx), {}, {
        action,
        status: tx.status.toLowerCase()
      }));
    }
    this.updateState({
      paymentTx: paymentTxs
    }, address);
  }
  async mergeXrplApiTxs(address) {
    let formattedAccountTxs = [];
    const network = this.getProviderConfig().networkKey;
    const chainCfg = this.chainCfgController.getXrplChainConfig(network);
    const accountTxs = await this.xrplJRPC.getAccountTransactions({
      account: address,
      limit: 100
    }); // TODO: Determine limit
    if (accountTxs.validated) {
      const currencyData = {
        selectedCurrency: this.getCurrentCurrency(),
        conversionRate: this.getConversionRate(),
        networkNativeCurrency: this.getNativeCurrency()
      };
      formattedAccountTxs = accountTxs.transactions.reduce((arr, transaction) => {
        if (!transaction.tx || !transaction.validated) {
          return arr;
        }
        const formattedAccTx = formatAccountTx(transaction, currencyData, address, chainCfg.chainId, chainCfg.blockExplorerUrl);
        arr.push(formattedAccTx);
        return arr;
      }, []);
    }
    const storedPastTx = this.getAddressState(address).formattedPastTransactions;
    let mergedTxs = formattedAccountTxs.concat(storedPastTx);
    const txSet = new Set();
    mergedTxs = mergedTxs.filter(tx => {
      const identifier = `${tx.chainId},${tx.transactionHash}`;
      if (!txSet.has(identifier)) {
        txSet.add(identifier);
        return true;
      }
      return false;
    }).sort((a, b) => Date.parse(b.rawDate) - Date.parse(a.rawDate));
    this.updateState({
      formattedPastTransactions: mergedTxs
    }, address);
  }
}

const NUMBER_OF_TOKENS_PRICE_TO_FETCH = 50;
class TokensInfoController extends BaseController {
  constructor(_ref) {
    let {
      state,
      config,
      provider,
      getProviderConfig,
      getIdentities,
      getCurrentConversionRate,
      getUsdConversionRate
    } = _ref;
    super({
      config,
      state
    });
    _defineProperty(this, "getProviderConfig", void 0);
    _defineProperty(this, "getCurrentConversionRate", void 0);
    _defineProperty(this, "getIdentities", void 0);
    _defineProperty(this, "getUsdConversionRate", void 0);
    _defineProperty(this, "xrplJrpcService", void 0);
    _defineProperty(this, "mutex", new Mutex());
    _defineProperty(this, "handle", void 0);
    this.defaultState = _objectSpread({
      tokenInfoLoadingState: LoadingState.FULL_RELOAD,
      supportedTokens: {},
      issuerAddressToNameMap: {}
    }, state);
    this.defaultConfig = _objectSpread({}, config);
    this.getProviderConfig = getProviderConfig;
    this.getCurrentConversionRate = getCurrentConversionRate;
    this.getUsdConversionRate = getUsdConversionRate;
    this.getIdentities = getIdentities;
    this.xrplJrpcService = new XrplJrpcService(provider);
    this.initialize();
  }
  async refreshTokensPrices() {
    let hasNetworkChanged = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let res;
    try {
      // firstly fetch the default supported tokens
      res = await this.fetchSupportedTokens(hasNetworkChanged);
      // store the user's custom fungible tokens details for all user accounts
      const customFungibleTokens = await this.fetchUserCustomFungibleTokens();
      this.update({
        tokenInfoLoadingState: LoadingState.LOADED,
        supportedTokens: res,
        customFungibleTokens
      });
    } catch (e) {
      log.error(e, "Error in resolving refreshTokensPrices");
      this.update({
        tokenInfoLoadingState: LoadingState.ERROR
      });
      this.update({
        tokenInfoLoadingState: LoadingState.ERROR
      });
    }
  }
  async poll() {
    const releaseLock = await this.mutex.acquire();
    if (this.handle) window.clearTimeout(this.handle);
    // this should never throw
    await this.refreshTokensPrices();
    releaseLock();
    this.handle = window.setTimeout(() => {
      this.poll();
    }, this.config.interval);
  }
  setTokenLoadingState() {
    this.update({
      tokenInfoLoadingState: LoadingState.FULL_RELOAD
    });
  }

  // fetch token details from the xrp meta public api
  async fetchCustomFungibleTokenDetails(_ref2) {
    let {
      issuerAddress,
      currencyCode
    } = _ref2;
    try {
      // verify the token validity against the xrp ledger
      const isTokenValid = await this.verifyTokenValidity({
        issuerAddress,
        currencyCode
      });
      if (!isTokenValid) {
        throw new Error("Invalid token!");
      }
      let tokenDetails;
      if (this.getProviderConfig().networkKey === DEFAULT_XRPL_NETWORK.mainnet) {
        // fetch details from xrpl meta api
        tokenDetails = await this.fetchTokenDetailsFromXrplMeta(currencyCode, issuerAddress);
        if (!tokenDetails) {
          throw new Error("Token details not found!");
        }
        return _objectSpread(_objectSpread({}, tokenDetails), {}, {
          currency: tokenDetails.currency.length > 3 ? parseCurrencyToReadableFormat(tokenDetails.currency) : tokenDetails.currency
        });
      }
      tokenDetails = await this.fetchIssuedTokenByAddressAndCurrencyCode(issuerAddress, currencyCode);
      return tokenDetails;
    } catch (err) {
      const error = err;
      const errMessage = error.status && error.statusText ? `${error.status}, ${error.statusText}` : error;
      throw new Error(`Failed to fetch token details::${errMessage}`);
    }
  }

  // for CDBC ledger
  async fetchCustomFungibleTokenDetailsByClientCode(clientCode) {
    try {
      const res = await this.fetchIssuedCustomTokenList(clientCode);
      if (res.length > 0) {
        const token = res[0];

        // verify the token validity against the ledger
        const isTokenValid = await this.verifyTokenValidity({
          issuerAddress: token.address,
          currencyCode: token.currencyCode
        });
        if (isTokenValid) {
          return res[0];
        }
        throw new Error(`Token with clientCode, ${token.clientCode} is not available in ${this.getProviderConfig().networkKey}`);
      }
      throw new Error(`Token not found with clientCode, ${clientCode}`);
    } catch (err) {
      const error = err;
      log.error(`error fetching token details by clientCode: ${error.message}`);
      throw err;
    }
  }

  // save user custom fungible token details (issuerName, tokenName etc...) in the backend db
  async saveCustomFungibleTokenDetails(_ref3) {
    let {
      tokenDetails
    } = _ref3;
    try {
      await post(`${this.config.api}/tokens/custom_fungible`, tokenDetails);
      // need to refresh the controller state
      await this.refreshTokensPrices();
    } catch (err) {
      const error = err;
      const errMessage = error.status && error.statusText ? `${error.status}, ${error.statusText}` : error;
      throw new Error(`Failed to save custom fungible token details: ${errMessage}`);
    }
  }

  // delete user custom fungible token from the backend database
  async deleteCustomFungibleTokenDetails(_ref4) {
    let {
      tokenDetails
    } = _ref4;
    try {
      const {
        networkKey
      } = this.getProviderConfig();
      await remove(`${this.config.api}/tokens/custom_fungible/${tokenDetails.symbol}:${tokenDetails.issuerAddress}?public_address=${tokenDetails.public_address}&network=${networkKey}`);
      // need to refresh the controller state
      await this.refreshTokensPrices();
    } catch (err) {
      const error = err;
      const errMessage = error.status && error.statusText ? `${error.status}, ${error.statusText}` : error;
      throw new Error(`Failed to delete custom fungible token details: ${errMessage}`);
    }
  }

  // fetch default supported tokens
  async fetchSupportedTokens() {
    let hasNetworkChanged = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let supportedTokensState = this.state.supportedTokens;
    let issuerAddressToNameMapState = this.state.issuerAddressToNameMap;
    if (Object.keys(supportedTokensState).length === 0 || hasNetworkChanged) {
      const network = this.getProviderConfig().networkKey;
      const {
        data
      } = await getSupportedTokensOmitPrice(this.config.api, network);
      supportedTokensState = data;
    }
    if (Object.keys(supportedTokensState).length && Object.keys(issuerAddressToNameMapState).length === 0 || hasNetworkChanged) {
      issuerAddressToNameMapState = Object.entries(supportedTokensState).reduce((obj, _ref5) => {
        let [issuer, tokenArr] = _ref5;
        obj[tokenArr[0].issuerAddress] = issuer;
        return obj;
      }, {});
      this.update({
        issuerAddressToNameMap: issuerAddressToNameMapState
      });
    }
    const supportedTokens = await this.parseSupportedTokensPrices(supportedTokensState);
    return supportedTokens;
  }
  async parseSupportedTokensPrices(supportedTokensOmitPrice) {
    const currentRate = this.getCurrentConversionRate();
    const usdRate = this.getUsdConversionRate();
    const usdToCurrentCurrencyRate = new BigNumber$1(currentRate).div(new BigNumber$1(usdRate));

    // Map payload to get token prices
    const tokenAggregatorPayload = Object.values(supportedTokensOmitPrice).reduce((arr, tokenArr) => {
      tokenArr.forEach(token => arr.push({
        currency: token.symbol,
        issuer: token.issuerAddress
      }));
      return arr;
    }, []);

    // Slice payload into chunks
    const tokenAggregatorPromises = [];
    const size = NUMBER_OF_TOKENS_PRICE_TO_FETCH;
    for (let i = 0; i < tokenAggregatorPayload.length; i += size) {
      const payloadChunk = tokenAggregatorPayload.slice(i, i + size);
      tokenAggregatorPromises.push(getTokensPrice(payloadChunk));
    }

    // Fetch token prices via chunks
    const tokens = await Promise.all(tokenAggregatorPromises);

    // Merge tokenAggregators from all chunks
    const tokenAggregators = tokens.reduce((arr, _ref6) => {
      let {
        tokens: tokenAggregatorArr
      } = _ref6;
      arr.push(...tokenAggregatorArr);
      return arr;
    }, []);

    // Index tokenAggregators by currency-issuer
    const tokenAggregatorsIndex = tokenAggregators.reduce((obj, _ref7, index) => {
      let {
        currency,
        issuer
      } = _ref7;
      obj[`${currency}-${issuer}`] = index;
      return obj;
    }, {});

    // Map token prices to supported tokens
    return Object.entries(supportedTokensOmitPrice).reduce((obj, _ref8) => {
      let [issuer, tokenArr] = _ref8;
      obj[issuer] = tokenArr.map(token => {
        var _tokenAggregatorsInde, _tokenAggregators$ind, _tokenAggregators$ind2;
        const key = `${token.symbol}-${token.issuerAddress}`;
        const index = (_tokenAggregatorsInde = tokenAggregatorsIndex[key]) !== null && _tokenAggregatorsInde !== void 0 ? _tokenAggregatorsInde : -1;
        let price = new BigNumber$1((_tokenAggregators$ind = (_tokenAggregators$ind2 = tokenAggregators[index]) === null || _tokenAggregators$ind2 === void 0 ? void 0 : _tokenAggregators$ind2.price_usd) !== null && _tokenAggregators$ind !== void 0 ? _tokenAggregators$ind : 0);

        // Static price for test tokens on testnet only
        if (key === "DEV-rBmsyNDDypKKQteuViAx4Sys23toSQ7Ejm") {
          price = new BigNumber$1(0.01);
        }
        price = price.multipliedBy(usdToCurrentCurrencyRate);
        return _objectSpread(_objectSpread({}, token), {}, {
          price
        });
      });
      return obj;
    }, {});
  }
  async fetchTokenDetailsFromXrplMeta(currencyCode, issuerAddress) {
    try {
      const tokenDetails = await get(`${XRPL_META_TOKENS_BASE_URL}/token/${currencyCode}:${issuerAddress}`, {
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      });
      if (!tokenDetails) {
        throw new Error("Token not found!");
      }
      return tokenDetails;
    } catch (err) {
      log.error("fetchTokenDetailsFromXrplMeta::error", err);
      throw new Error(`Invalid Token. (${err.message}).`);
    }
  }
  async fetchIssuedCustomTokenList(clientCode) {
    try {
      const providerCfg = this.getProviderConfig();
      const clientCodeQuery = clientCode && clientCode.trim().length > 0 ? `&clientCode=${clientCode}` : "";
      const resp = await get(`${this.config.api}/tokens/custom_fungible/issued_currencies?network=${providerCfg.networkKey}${clientCodeQuery}`, {
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      });
      return resp.data;
    } catch (err) {
      log.error("Failed to fetch token list:", err);
    }
  }
  async fetchIssuedTokenByAddressAndCurrencyCode(address, currencyCode) {
    const resp = await get(`${this.config.api}/tokens/custom_fungible/issuer_address/${address}/currency/${currencyCode}`, {
      headers: {
        "Content-Type": "application/json; charset-utf-8"
      }
    });
    if (resp.data) {
      return resp.data;
    }
    throw new Error(resp.message);
  }
  async verifyTokenValidity(_ref9) {
    let {
      issuerAddress,
      currencyCode
    } = _ref9;
    try {
      var _accLinesResult$lines;
      let accLinesResult = await this.xrplJrpcService.getAccountLines({
        account: issuerAddress,
        limit: 200
      });
      // most likely be the issuer doesn't exist in the ledger,
      if (!accLinesResult) {
        return false;
      }

      // verify against the currency code of the lines array
      const formattedCurrency = currencyCode.length > 3 ? parseCurrencyToReadableFormat(currencyCode) : currencyCode;
      let found = (_accLinesResult$lines = accLinesResult.lines) === null || _accLinesResult$lines === void 0 ? void 0 : _accLinesResult$lines.some(line => line.currency.toLowerCase() === formattedCurrency.toLowerCase());

      // if the currency code cannot be found in the first page, query next page until the currencyCode is found or there're no mroe lines left
      while (found !== true && (_accLinesResult = accLinesResult) !== null && _accLinesResult !== void 0 && _accLinesResult.marker && ((_accLinesResult2 = accLinesResult) === null || _accLinesResult2 === void 0 ? void 0 : _accLinesResult2.lines.length) > 0) {
        var _accLinesResult, _accLinesResult2, _accLinesResult$lines2;
        // fetch next page
        accLinesResult = await this.xrplJrpcService.getAccountLines({
          account: issuerAddress,
          limit: 200,
          marker: accLinesResult.marker
        });
        found = (_accLinesResult$lines2 = accLinesResult.lines) === null || _accLinesResult$lines2 === void 0 ? void 0 : _accLinesResult$lines2.some(line => line.currency.toLowerCase() === formattedCurrency.toLowerCase());
      }
      return found;
    } catch (err) {
      throw new Error(err.message);
    }
  }

  // fetch user owned custom fungible tokens for user's available wallets in the current selected network
  async fetchUserCustomFungibleTokens() {
    try {
      const {
        networkKey
      } = this.getProviderConfig();
      const addresses = Object.keys(this.getIdentities() || {});
      const customFungibleTokens = {};
      for (let i = 0; i < addresses.length; i++) {
        const res = await get(`${this.config.api}/tokens/custom_fungible?public_address=${addresses[i]}&network=${networkKey}`, {
          headers: {
            "Content-Type": "application/json; charset=utf-8"
          }
        });
        const formattedTokenDetails = res.data.map(r => _objectSpread(_objectSpread({}, r), {}, {
          price: new BigNumber$1(parseInt(r.price))
        }));
        customFungibleTokens[addresses[i]] = formattedTokenDetails;
      }
      return customFungibleTokens;
    } catch (err) {
      log.error("Failed to fetch custom fungible token details list", err);
    }
  }
}

class TokensTrackerController extends BaseController {
  constructor(_ref) {
    let {
      state,
      config,
      provider,
      getIdentities,
      getProviderConfig,
      getXRPLChainConfig,
      getFormattedPastTransactions
    } = _ref;
    super({
      config,
      state
    });
    _defineProperty(this, "xrplJRPC", void 0);
    _defineProperty(this, "getIdentities", void 0);
    _defineProperty(this, "getProviderConfig", void 0);
    _defineProperty(this, "getXRPLChainConfig", void 0);
    _defineProperty(this, "getFormattedPastTransactions", void 0);
    _defineProperty(this, "mutex", new Mutex());
    _defineProperty(this, "handle", void 0);
    this.defaultState = _objectSpread({
      lines: undefined,
      pendingLines: undefined
    }, state);
    this.defaultConfig = _objectSpread({}, config);
    this.initialize();
    this.xrplJRPC = new XrplJrpcService(provider);
    this.getIdentities = getIdentities;
    this.getProviderConfig = getProviderConfig;
    this.getXRPLChainConfig = getXRPLChainConfig;
    this.getFormattedPastTransactions = getFormattedPastTransactions;
  }
  async refreshTokens() {
    const addresses = Object.keys(this.getIdentities() || {});
    let res;
    try {
      res = await Promise.all(addresses.map(address => this.getAccountLines(address)));
    } catch (e) {
      log.error(e, `Error in resolving getAccountLines for addresses ${addresses.map(x => x.toString())}`);
    }
    const network = this.getProviderConfig().networkKey;
    // verify that current network config is in the available network lists
    const {
      chainId
    } = this.getXRPLChainConfig(network);
    if (!res || !chainId) return;
    res.forEach((accountLines, index) => {
      var _this$state$lines, _this$state$pendingLi;
      const lines = (_this$state$lines = this.state.lines) !== null && _this$state$lines !== void 0 ? _this$state$lines : {};
      const pendingLines = (_this$state$pendingLi = this.state.pendingLines) !== null && _this$state$pendingLi !== void 0 ? _this$state$pendingLi : {};
      const submittedTrustSets = this.getFormattedPastTransactions(addresses[index]).filter(tx => tx.status === TransactionStatus.submitted && tx.transactionCategory === TransactionTypes.TrustSet && tx.chainId === chainId);
      const submittedTrustSetsIds = submittedTrustSets.reduce((set, trustSet) => {
        set.add(`${trustSet.ticker}-${trustSet.to}`);
        return set;
      }, new Set());
      const filteredAccountLines = accountLines.lines.filter(line => !submittedTrustSetsIds.has(`${line.currency}-${line.account}`));
      this.update({
        lines: _objectSpread(_objectSpread({}, lines), {}, {
          [addresses[index]]: filteredAccountLines
        }),
        pendingLines: _objectSpread(_objectSpread({}, pendingLines), {}, {
          [addresses[index]]: submittedTrustSets
        })
      });
    });
  }
  async poll() {
    let releaseLock;
    try {
      releaseLock = await this.mutex.acquire();
      if (this.handle) window.clearTimeout(this.handle);
      // this should never throw
      await this.refreshTokens();
      this.handle = window.setTimeout(() => {
        this.poll();
      }, this.config.interval);
    } finally {
      var _releaseLock;
      (_releaseLock = releaseLock) === null || _releaseLock === void 0 || _releaseLock();
    }
  }
  async getAccountLines(address) {
    try {
      return await this.xrplJRPC.getAccountLines({
        account: address,
        limit: 100 /* TODO: Determine limit */
      });
    } catch (error) {
      if (error.message.includes("actNotFound")) {
        return new Promise(resolve => {
          resolve({
            status: "error",
            account: address,
            lines: []
          });
        });
      }
      throw error;
    }
  }
}

class AccountSequenceTracker {
  constructor(_ref) {
    let {
      accountTracker,
      getPendingTransactions
    } = _ref;
    _defineProperty(this, "accountTracker", void 0);
    _defineProperty(this, "getPendingTransactions", void 0);
    _defineProperty(this, "lockMap", void 0);
    this.accountTracker = accountTracker;
    this.getPendingTransactions = getPendingTransactions;
    this.lockMap = {};
  }

  /**
    this will return an object with the `nextNonce` 
    `nonceDetails`, and the releaseLock.
    Note: releaseLock must be called after adding a signed tx 
    to pending transactions (or discarding).
  */
  async getAccountSequenceLock(address) {
    // eslint-disable-next-line no-console
    console.log("getAccountSequenceLock");
    // await lock free, then take lock
    const releaseLock = await this._aquireLock(address);
    try {
      // evaluate multiple nextNonce strategies
      const nextNetworkAccountSequence = await this.accountTracker.getAccountSequence(address);
      const nextLocalAccountSequence = this._getLocalAccountSequence(address);
      const nextSequence = Math.max(nextNetworkAccountSequence, nextLocalAccountSequence);
      return {
        nextSequence,
        releaseLock
      };
    } catch (error) {
      // release lock if we encounter an error
      releaseLock();
      throw error;
    }
  }
  releaseLockIfExists(lockId) {
    const mutex = this.lockMap[lockId];
    if (mutex) {
      mutex.release();
      delete this.lockMap[lockId];
    }
  }
  async _aquireLock(lockId) {
    const mutex = this._lookupMutex(lockId);
    const releaseLock = await mutex.acquire();
    return releaseLock;
  }
  _lookupMutex(lockId) {
    let mutex = this.lockMap[lockId];
    if (!mutex) {
      mutex = new Mutex();
      this.lockMap[lockId] = mutex;
    }
    return mutex;
  }
  _getLocalAccountSequence(address) {
    const pendingTxs = this.getPendingTransactions(address);
    const sequences = pendingTxs.map(txMeta => {
      const {
        Sequence
      } = txMeta.transaction;
      return Sequence;
    });
    const highestSeq = Math.max.apply(null, sequences);
    return Number.isInteger(highestSeq) ? highestSeq + 1 : 0;
  }
}

class PendingTransactionTracker {
  constructor(_ref) {
    let {
      provider,
      getPendingTransactions,
      emit
    } = _ref;
    _defineProperty(this, "getPendingTransactions", void 0);
    _defineProperty(this, "provider", void 0);
    _defineProperty(this, "emit", void 0);
    _defineProperty(this, "xrplJRPC", void 0);
    this.provider = provider;
    this.getPendingTransactions = getPendingTransactions;
    this.emit = emit;
    this.xrplJRPC = new XrplJrpcService(this.provider);
  }

  /**
    checks the network for signed txs and releases the nonce global lock if it is
  */
  async updatePendingTxs(currentLedgerState) {
    // in order to keep the nonceTracker accurate we block it while updating pending transactions
    try {
      const pendingTxs = this.getPendingTransactions();
      await Promise.all(pendingTxs.map(txMeta => this._checkPendingTx(txMeta, currentLedgerState)));
    } catch (error) {
      log.error("PendingTransactionTracker - Error updating pending transactions");
      log.error(error);
    }
  }
  async _checkPendingTx(foundTx, currentLedgerState) {
    const txMeta = foundTx;
    const txHash = txMeta.transactionHash;
    const txId = txMeta.id;

    // Only check submitted txs
    if (txMeta.status !== TransactionStatus.submitted) return;

    // extra check in case there was an uncaught error during the
    // signature and submission process
    if (!txHash) {
      const noTxHashError = new Error("We had an error while submitting this transaction, please try again.");
      noTxHashError.name = "NoTxHashError";
      this.emit(TX_EVENTS.TX_FAILED, {
        txId,
        error: noTxHashError
      });
      return;
    }
    try {
      const {
        txValidated,
        txReceipt
      } = await this.xrplJRPC.getTransactionStatus(txHash);
      log.info("pending tx found", txValidated);
      // tx in not validated yet
      if (!txValidated) {
        const isExpired = _checkIfTxExpired(txMeta.transaction.LastLedgerSequence, txHash, currentLedgerState.ledger_index);
        if (isExpired) {
          this.emit(TX_EVENTS.TX_EXPIRED, {
            txId
          });
          return;
        }
      }

      // tx is validated, check for result
      if (txValidated) {
        var _txReceipt$meta;
        if ((txReceipt === null || txReceipt === void 0 || (_txReceipt$meta = txReceipt.meta) === null || _txReceipt$meta === void 0 ? void 0 : _txReceipt$meta.TransactionResult) === "tesSUCCESS") {
          this.emit(TX_EVENTS.TX_CONFIRMED, {
            txId,
            txReceipt
          });
        } else {
          var _txReceipt$meta2;
          const txFailError = new Error((txReceipt === null || txReceipt === void 0 || (_txReceipt$meta2 = txReceipt.meta) === null || _txReceipt$meta2 === void 0 ? void 0 : _txReceipt$meta2.TransactionResult) || "Something went wrong");
          txFailError.name = "txFailed";
          this.emit(TX_EVENTS.TX_FAILED, {
            txId,
            error: txFailError
          });
        }
      }
    } catch (error) {
      log.error("error while loading tx", error);
      txMeta.warning = {
        error: error.message,
        message: "There was a problem loading this transaction."
      };
      this.emit(TX_EVENTS.TX_WARNING, {
        txMeta
      });
    }
  }
}

class Amount {
  constructor(amount) {
    let drops = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    _defineProperty(this, "amount", void 0);
    // validate

    if (typeof amount === "string" && !drops) {
      if (!amount.match(/^[+-]?\d+(?:[.]*\d*(?:[eE][+-]?\d+)?)?$/)) {
        throw new Error(`invalid value '${amount}', should be a number`);
      } else if (amount === ".") {
        throw new Error(`invalid value '${amount}',  should be a BigNumber or string-encoded number.`);
      }
    }

    // Converting to BigNumber and then back to string should remove any
    // decimal point followed by zeros, e.g. '1.00'.
    // Important: specify to fixed to avoid exponential notation, e.g. '1e-7'.
    const newAmount = new BigNumber(amount).toFixed();
    if (drops) {
      // drops are only whole units
      if (newAmount.includes(".")) {
        throw new Error(`value '${amount}' has too many decimal places.`);
      }
    }
    this.amount = new BigNumber(newAmount);
  }
  dropsToXrp() {
    let toNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    const xrp = this.amount.dividedBy(1000000.0);
    if (toNumber) {
      return xrp.toNumber();
    }
    return xrp.toString(10);
  }
  xrpToDrops() {
    let toNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    const drops = this.amount.times(1000000.0).decimalPlaces(0);
    if (toNumber) {
      return drops.toNumber();
    }
    return drops.toString(10);
  }
  withTransferRate(transferRate) {
    let toNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const withRate = this.amount.plus(this.amount.multipliedBy(transferRate).dividedBy(100));
    if (toNumber) {
      return withRate.toNumber();
    }
    return withRate.toString(10);
  }
  toString() {
    let toFixed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (toFixed) {
      return this.amount.toFixed();
    }
    return this.amount.toString();
  }
  toNumber() {
    return this.amount.toNumber();
  }
}

class TransactionSerializer {
  constructor(tx) {
    _defineProperty(this, "tx", void 0);
    _defineProperty(this, "fields", void 0);
    _defineProperty(this, "ledgerTracker", void 0);
    _defineProperty(this, "accountTracker", void 0);
    _defineProperty(this, "xrplJRPC", void 0);
    this.tx = tx;
    this.fields = ["TransactionType", "SignedBlob", "Account", "Memos", "Flags", "Fee", "Sequence", "TicketSequence", "AccountTxnID", "LastLedgerSequence", "Signers", "SourceTag", "SigningPubKey", "TxnSignature"];
  }
  get TransactionType() {
    return get$1(this, ["tx", "TransactionType"], undefined);
  }
  get Account() {
    const source = get$1(this, ["tx", "Account"], undefined);
    const sourceTag = get$1(this, ["tx", "SourceTag"], undefined);
    if (!source) return undefined;
    return {
      address: source,
      tag: sourceTag
    };
  }
  get Fee() {
    const fee = get$1(this, ["tx", "Fee"], undefined);
    if (isUndefined(fee)) return undefined;
    return new Amount(fee).dropsToXrp();
  }
  get SubmitResult() {
    return get$1(this, "submitResult", undefined);
  }
  get VerifyResult() {
    const result = get$1(this, "verifyResult", undefined);
    if (isUndefined(result)) {
      return {
        success: false
      };
    }
    return result;
  }
  get Hash() {
    return get$1(this, ["tx", "hash"]);
  }
  get LedgerIndex() {
    return get$1(this, ["tx", "ledger_index"]);
  }

  // serialize transaction object to rippled tx json
  get Json() {
    const tx = {};
    // eslint-disable-next-line no-console
    console.log("Object.getOwnPropertyNames(this.tx)", Object.getOwnPropertyNames(this.tx));
    Object.getOwnPropertyNames(this.tx).forEach(k => {
      if (this.fields.includes(k)) {
        tx[k] = this.tx[k];
      }
    });
    return tx;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get Signers() {
    const signers = get$1(this, ["tx", "Signers"]);
    return flatMap(signers, e => {
      return {
        account: e.Signer.Account,
        signature: e.Signer.TxnSignature,
        pubKey: e.Signer.SigningPubKey
      };
    });
  }
  get SigningPubKey() {
    return get$1(this, ["tx", "SigningPubKey"]);
  }
  get Sequence() {
    return get$1(this, ["tx", "Sequence"], undefined);
  }
  get SignedBlob() {
    return get$1(this, ["tx", "SignedBlob"], undefined);
  }
  get TicketSequence() {
    return get$1(this, ["tx", "TicketSequence"], undefined);
  }
  get LastLedgerSequence() {
    return get$1(this, ["tx", "LastLedgerSequence"], undefined);
  }
  get PreviousTxnID() {
    return get$1(this, ["tx", "PreviousTxnID"], undefined);
  }
  get TxnSignature() {
    return get$1(this, ["tx", "TxnSignature"], undefined);
  }
  get Index() {
    return get$1(this, ["tx", "Index"], undefined);
  }
  set TransactionType(type) {
    set(this, ["tx", "TransactionType"], type);
  }
  set Account(account) {
    if (has(account, "address")) {
      set(this, "tx.Account", account.address);
    }
    if (has(account, "tag")) {
      set(this, "tx.SourceTag", account.tag);
    }
  }
  set Fee(fee) {
    set(this, ["tx", "Fee"], new Amount(fee, false).xrpToDrops());
  }
  set SubmitResult(result) {
    set(this, "submitResult", result);
  }
  set VerifyResult(result) {
    set(this, "verifyResult", result);
  }
  set Hash(hash) {
    set(this, ["tx", "hash"], hash);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set Signers(signers) {
    set(this, ["tx", "Signers"], signers);
  }
  set SigningPubKey(signingPubKey) {
    set(this, ["tx", "SigningPubKey"], signingPubKey);
  }
  set Sequence(sequence) {
    set(this, ["tx", "Sequence"], sequence);
  }
  set TicketSequence(ticketSequence) {
    set(this, ["tx", "TicketSequence"], ticketSequence);
  }
  set LastLedgerSequence(ledgerSequence) {
    set(this, ["tx", "LastLedgerSequence"], ledgerSequence);
  }
  set PreviousTxnID(id) {
    set(this, ["tx", "PreviousTxnID"], id);
  }
  set TxnSignature(signature) {
    set(this, ["tx", "TxnSignature"], signature);
  }
  set SignedBlob(signedBlb) {
    set(this, ["tx", "SignedBlob"], signedBlb);
  }

  // Nft tx related fields
  set Index(index) {
    set(this, ["tx", "Index"], index);
  }
}

class BaseTransaction extends TransactionSerializer {
  constructor(config, tx) {
    super(tx);
    _defineProperty(this, "ClassName", "Transaction");
    _defineProperty(this, "availableNetworkFee", void 0);
    _defineProperty(this, "isAborted", void 0);
    _defineProperty(this, "isSubmitted", void 0);
    _defineProperty(this, "signTransaction", void 0);
    _defineProperty(this, "accountSequenceTracker", void 0);
    const {
      ledgerTracker,
      accountTracker,
      provider,
      accountSequenceTracker,
      signTransaction
    } = config;
    this.signTransaction = signTransaction;
    this.ledgerTracker = ledgerTracker;
    this.accountTracker = accountTracker;
    this.accountSequenceTracker = accountSequenceTracker;
    this.xrplJRPC = new XrplJrpcService(provider);
    this.fields = ["TransactionType", "SignedBlob", "Account", "Memos", "Flags", "Fee", "Sequence", "TicketSequence", "AccountTxnID", "LastLedgerSequence", "Signers", "SourceTag", "SigningPubKey", "TxnSignature"];
  }
  async validate() {
    let isGeneric = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!Object.values(TransactionTypes).includes(this.TransactionType) && !isGeneric) {
      throw new Error(`Unsupported transaction type: ${this.TransactionType}`);
    }
    if (this.Sequence && this.LastLedgerSequence && this.Sequence > this.LastLedgerSequence) {
      throw new Error(`transaction with hash: ${this.Hash} is expired, last settled ledger sequence is: ${this.LastLedgerSequence}, whereas given transaction sequence is: ${this.Sequence}`);
    }
    validateBaseTransaction(this.tx);
  }
  async prepare() {
    if (!this.Fee) {
      throw new Error("Transaction fee is missing in transaction");
    }

    // if account sequence not set get the latest account sequence
    if (isUndefined(this.Sequence)) {
      try {
        const sequenceLockInfo = await this.accountSequenceTracker.getAccountSequenceLock(this.Account.address);
        this.Sequence = sequenceLockInfo.nextSequence;
      } catch (error) {
        if (error.message.includes("actNotFound")) {
          // hack to prevent forever loading in case of embed txns
          this.Sequence = 0;
        } else {
          throw new Error("Unable to set account sequence");
        }
      }
    }
  }
  populateLastLedgerSequence() {
    let ledgerOffset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    // if no LastLedgerSequence or LastLedgerSequence is already pass the threshold
    // update with LastLedger + 10

    const lastLedgerIndex = this.ledgerTracker.lastClosedLedgerIndex;
    // if unable to fetch the LastLedger probably user is not connected to the node
    if (!lastLedgerIndex) {
      throw new Error("Unable to get last closed ledger");
    }
    // expected LastLedger sequence
    const ExpectedLastLedger = lastLedgerIndex + ledgerOffset;
    // if LastLedgerSequence is not set
    if (isUndefined(this.LastLedgerSequence)) {
      // only set if last ledger is set
      this.LastLedgerSequence = ExpectedLastLedger;
    } else if (this.LastLedgerSequence < ExpectedLastLedger) {
      // the Last Ledger is already passed, update it base on Last ledger
      this.LastLedgerSequence = ExpectedLastLedger;
    }
  }
  async loadTransactionFee() {
    let isMultiSign = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    // set the fee if not set and can override the details of transaction
    const shouldOverrideFee = typeof this.Fee === "undefined" && !isMultiSign;
    if (shouldOverrideFee) {
      // calculate and persist the transaction fees
      const availableNetworkFee = await this.ledgerTracker.getAvailableNetworkFee();

      // normalize suggested and available fees base on transaction type
      const availableFees = availableNetworkFee.availableFees.map(fee => {
        return {
          type: fee.type,
          value: this.calculateFee(fee.value),
          suggested: fee.suggested
        };
      });

      // get suggested fee
      const suggestedFee = find(availableFees, {
        suggested: true
      });
      this.Fee = new Amount(suggestedFee.value).dropsToXrp();
      this.availableNetworkFee = availableNetworkFee;
    }
  }
  async sign(account) {
    let multisign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!account) {
      throw new Error("Account param is required!");
    }
    if (this.SignedBlob) {
      throw new Error("Transaction already signed!");
    }

    // if account not set , set the signing account
    if (isUndefined(this.Account)) {
      this.Account = {
        address: account.address
      };
    }

    // prepare transaction for signing
    // skip if multiSing transaction
    if (!multisign) {
      await this.prepare();
    }

    // if transaction aborted then don't continue
    if (this.isAborted) {
      throw new Error("Transaction aborted!");
    }
    const txSignRes = this.signTransaction(this.tx, account.address, {
      multisign
    });
    this.releaseAccountLock(account);
    this.SignedBlob = txSignRes.tx_blob;
    return txSignRes.tx_blob;
  }
  async submit() {
    try {
      var _result$tx_json;
      // if transaction is not signed exit
      if (!this.SignedBlob) {
        throw new Error("transaction is not signed!");
      }

      // if transaction is already submitted exit
      if (this.SubmitResult || this.isSubmitted) {
        throw new Error("transaction is in submitting phase or has been submitted to the ledger!");
      }

      // if transaction aborted then don't continue
      if (this.isAborted) {
        throw new Error("Transaction aborted!");
      }

      // set isSubmitted to true for preventing the transaction to be submitted multiple times
      this.isSubmitted = true;

      // Submit signed transaction to the XRPL
      const result = await this.xrplJRPC.submitTransaction(this.SignedBlob);
      // eslint-disable-next-line no-console
      console.log("tx result: ", result);
      const submitResult = {
        success: result.status === "success" && result.accepted,
        engineResult: result.engine_result,
        message: result.engine_result_message,
        hash: (_result$tx_json = result.tx_json) === null || _result$tx_json === void 0 ? void 0 : _result$tx_json.hash
      };
      // set submit result
      this.SubmitResult = submitResult;
      return submitResult;
    } catch (e) {
      log.error("submit transaction error: ", e);
      // something wrong happened
      const result = {
        success: false,
        engineResult: "telFAILED",
        message: e === null || e === void 0 ? void 0 : e.message,
        node: undefined,
        nodeType: undefined
      };

      // set submit result
      this.SubmitResult = result;
      return result;
    }
  }
  releaseAccountLock(account) {
    this.accountSequenceTracker.releaseLockIfExists(account.address);
  }
  abort() {
    this.isAborted = true;
  }
  calculateFee() {
    let netFee = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
    const baseFee = new BigNumber(netFee);
    return baseFee.toString();
  }
}

class Generic extends BaseTransaction {
  constructor(config) {
    let tx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super(config, tx);

    // set transaction type if not set
    _defineProperty(this, "Type", Generic.Type);
    if (isUndefined(this.TransactionType)) {
      this.TransactionType = Generic.Type;
    }
    const txFields = new Set(Object.keys(tx));
    this.fields = [...new Set([...this.fields, ...txFields])];
  }
  async validate() {
    await super.validate(true);
  }
}
_defineProperty(Generic, "Type", TransactionTypes.Others);

class NFTokenAcceptOffer extends BaseTransaction {
  constructor(config, tx) {
    super(config, tx);

    // set transaction type if not set
    _defineProperty(this, "Type", NFTokenAcceptOffer.Type);
    if (isUndefined(this.TransactionType)) {
      this.TransactionType = NFTokenAcceptOffer.Type;
    }
    this.fields = this.fields.concat(["NFTokenSellOffer", "NFTokenBuyOffer", "NFTokenBrokerFee"]);
  }
  get NFTokenSellOffer() {
    return get$1(this, ["tx", "NFTokenSellOffer"]);
  }
  get NFTokenBuyOffer() {
    return get$1(this, ["tx", "NFTokenBuyOffer"]);
  }
  get NFTokenBrokerFee() {
    let brokerFee = undefined;
    brokerFee = get$1(this, ["tx", "NFTokenBrokerFee"]);
    if (isUndefined(brokerFee)) return undefined;
    if (typeof brokerFee === "string") {
      return {
        currency: "XRP",
        value: new Amount(brokerFee).dropsToXrp()
      };
    }
    return {
      currency: brokerFee.currency,
      value: brokerFee.value,
      issuer: brokerFee.issuer
    };
  }
}
_defineProperty(NFTokenAcceptOffer, "Type", TransactionTypes.NFTokenAcceptOffer);

class NFTokenCancelOffer extends BaseTransaction {
  constructor(config, tx) {
    super(config, tx);

    // set transaction type if not set
    _defineProperty(this, "Type", NFTokenCancelOffer.Type);
    if (isUndefined(this.TransactionType)) {
      this.TransactionType = NFTokenCancelOffer.Type;
    }
    this.fields = this.fields.concat(["NFTokenOffers"]);
  }
  get NFTokenOffers() {
    return get$1(this, ["tx", "NFTokenOffers"]);
  }
}
_defineProperty(NFTokenCancelOffer, "Type", TransactionTypes.NFTokenCancelOffer);

class LedgerDate {
  constructor(date) {
    _defineProperty(this, "date", void 0);
    this.date = date;
  }
  static ledgerToUnixTimestamp(rpepoch) {
    return (rpepoch + 0x386d4380) * 1000;
  }
  static unixToLedgerTimestamp(timestamp) {
    return Math.round(timestamp / 1000) - 0x386d4380;
  }
  toISO8601() {
    return new Date(LedgerDate.ledgerToUnixTimestamp(this.date)).toISOString();
  }
  toLedgerTime() {
    return LedgerDate.unixToLedgerTimestamp(Date.parse(this.date));
  }
}

class NFTokenCreateOffer extends BaseTransaction {
  constructor(config, tx) {
    super(config, tx);

    // set transaction type if not set
    _defineProperty(this, "Type", NFTokenCreateOffer.Type);
    if (isUndefined(this.TransactionType)) {
      this.TransactionType = NFTokenCreateOffer.Type;
    }
    this.fields = this.fields.concat(["Amount", "Destination", "Expiration", "Owner", "NFTokenID", "Index"]);
  }
  get Json() {
    const tx = {};
    // eslint-disable-next-line no-console
    console.log("Object.getOwnPropertyNames(this.tx)", Object.getOwnPropertyNames(this.tx));
    Object.getOwnPropertyNames(this.tx).forEach(k => {
      if (this.fields.includes(k)) {
        tx[k] = this.tx[k];
      }
    });
    return tx;
  }
  get Amount() {
    let amount = undefined;
    amount = get$1(this, ["tx", "Amount"]);
    if (isUndefined(amount)) return undefined;
    if (typeof amount === "string") {
      return {
        currency: "XRP",
        value: new Amount(amount).dropsToXrp()
      };
    }
    return {
      currency: amount.currency,
      value: amount.value,
      issuer: amount.issuer
    };
  }
  get Destination() {
    const destination = get$1(this, ["tx", "Destination"], undefined);
    if (isUndefined(destination)) return undefined;
    return {
      address: destination
    };
  }
  get Expiration() {
    const date = get$1(this, ["tx", "Expiration"], undefined);
    if (isUndefined(date)) return undefined;
    const ledgerDate = new LedgerDate(date);
    return ledgerDate.toISO8601();
  }
  get Owner() {
    return get$1(this, ["tx", "Owner"]);
  }
  get NFTokenID() {
    return get$1(this, ["tx", "NFTokenID"]);
  }
  get Index() {
    const account = get$1(this, ["tx", "Owner"], undefined);
    const sequence = get$1(this, ["tx", "Sequence"], undefined);
    return hashMessage(`0x0074${account}${sequence}`).toString("hex");
  }

  // Nft tx related fields
  set Index(index) {
    set(this, ["tx", "index"], index);
  }
}
_defineProperty(NFTokenCreateOffer, "Type", TransactionTypes.NFTokenCreateOffer);

const PAYMENT_NO_TRUSTLINE_ERROR_MSG = "unable to send payment, recipient doesn't have trustline";
const NFTOKEN_NOT_TRANSFERABLE = "The specified NFToken is not transferable.";

class Payment extends BaseTransaction {
  constructor(config, tx) {
    super(config, tx);

    // set transaction type if not set
    _defineProperty(this, "Type", Payment.Type);
    if (isUndefined(this.TransactionType)) {
      this.TransactionType = Payment.Type;
    }
    this.fields = this.fields.concat(["Destination", "DestinationTag", "InvoiceID", "Paths", "Amount", "SendMax", "DeliverMin"]);
  }
  get Destination() {
    const destination = get$1(this, ["tx", "Destination"], undefined);
    const destinationTag = get$1(this, ["tx", "DestinationTag"], undefined);
    if (isUndefined(destination)) return undefined;
    return {
      address: destination,
      tag: destinationTag
    };
  }
  get Amount() {
    let amount = undefined;
    amount = get$1(this, ["tx", "Amount"]);
    if (isUndefined(amount)) return undefined;
    if (typeof amount === "string") {
      return {
        currency: "XRP",
        value: new Amount(amount).dropsToXrp()
      };
    }
    return {
      currency: amount.currency,
      value: amount.value,
      issuer: amount.issuer
    };
  }
  get DeliverMin() {
    const deliverMin = get$1(this, ["tx", "DeliverMin"], undefined);
    if (!deliverMin) {
      return undefined;
    }
    if (typeof deliverMin === "string") {
      return {
        currency: "XRP",
        value: new Amount(deliverMin).dropsToXrp()
      };
    }
    return {
      currency: deliverMin.currency,
      value: deliverMin.value,
      issuer: deliverMin.issuer
    };
  }
  get InvoiceID() {
    return get$1(this, "tx.InvoiceID", undefined);
  }
  get SendMax() {
    const sendMax = get$1(this, ["tx", "SendMax"], undefined);
    if (!sendMax) {
      return undefined;
    }
    if (typeof sendMax === "string") {
      return {
        currency: "XRP",
        value: new Amount(sendMax).dropsToXrp()
      };
    }
    return {
      currency: sendMax.currency,
      value: sendMax.value,
      issuer: sendMax.issuer
    };
  }
  set Amount(input) {
    // XRP
    if (typeof input === "string") {
      set(this, "tx.Amount", new Amount(input, false).xrpToDrops());
    }
    if (typeof input === "object") {
      set(this, "tx.Amount", {
        currency: input.currency,
        value: input.value,
        issuer: input.issuer
      });
    }
  }
  set Destination(destination) {
    if (has(destination, "address")) {
      if (!AccountLib.utils.isValidAddress(destination.address)) {
        throw new Error(`${destination.address} is not a valid XRP Address`);
      }
      set(this, "tx.Destination", destination.address);
    }
    if (has(destination, "tag")) {
      const tag = get$1(destination, "tag", undefined);
      if (tag !== undefined && tag !== null && tag !== "") {
        // try to convert to number if not
        if (!isNumber(tag)) {
          set(this, "tx.DestinationTag", toInteger(tag));
        } else {
          set(this, "tx.DestinationTag", tag);
        }
      } else {
        set(this, "tx.DestinationTag", undefined);
      }
    }
  }
  set SendMax(input) {
    if (typeof input === "undefined") {
      set(this, "tx.SendMax", undefined);
      return;
    }
    // XRP
    if (typeof input === "string") {
      set(this, "tx.SendMax", new Amount(input, false).xrpToDrops());
    }
    if (typeof input === "object") {
      set(this, "tx.SendMax", {
        currency: input.currency,
        value: input.value,
        issuer: input.issuer
      });
    }
  }
  set DeliverMin(input) {
    if (typeof input === "undefined") {
      set(this, "tx.DeliverMin", undefined);
      return;
    }

    // XRP
    if (typeof input === "string") {
      set(this, "tx.DeliverMin", new Amount(input, false).xrpToDrops());
      return;
    }
    set(this, "tx.DeliverMin", {
      currency: input.currency,
      value: input.value,
      issuer: input.issuer
    });
  }
  set InvoiceID(invoiceId) {
    set(this, "tx.InvoiceID", invoiceId);
  }
  async validate() {
    var _this$Amount, _this$Amount2;
    await super.validate();
    validatePayment(this.tx);
    // check if amount is present
    if (!this.Amount || !((_this$Amount = this.Amount) !== null && _this$Amount !== void 0 && _this$Amount.value) || ((_this$Amount2 = this.Amount) === null || _this$Amount2 === void 0 ? void 0 : _this$Amount2.value) === "0") {
      throw new Error("Amount is missing in transaction");
    }

    // check if recipient have proper TrustLine when delivering IOU/token
    // Note: ignore if sending to the issuer
    if (this.Amount.currency !== "XRP" && this.Amount.issuer !== this.Destination.address) {
      const destinationLine = await this.accountTracker.getFilteredAccountLine(this.Destination.address, this.Amount);
      if (!destinationLine || Number(destinationLine.limit) === 0 && Number(destinationLine.balance) === 0) {
        throw new Error(PAYMENT_NO_TRUSTLINE_ERROR_MSG);
      }
    }
    let XRPAmount = undefined;

    // SendMax have higher priority
    if (this.SendMax && this.SendMax.currency === "XRP") {
      XRPAmount = this.SendMax;
    } else if (this.Amount.currency === "XRP" && !this.SendMax) {
      XRPAmount = this.Amount;
    }
    if (XRPAmount) {
      const {
        availableBalance
      } = await this.accountTracker.getAvailableBalance(this.Account.address, this.ledgerTracker.state._currentLedgerState);
      if (Number(XRPAmount.value) > Number(availableBalance)) {
        throw new Error(`Insufficient spendable balance, current balance is: ${Number(availableBalance)} and required is: ${Number(XRPAmount.value)}`);
      }
    }
    let IOUAmount = undefined;

    // SendMax have higher priority
    if (this.SendMax && this.SendMax.currency !== "XRP") {
      IOUAmount = this.SendMax;
    } else if (this.Amount.currency !== "XRP" && !this.SendMax) {
      IOUAmount = this.Amount;
    }
    if (IOUAmount) {
      // sender is not issuer
      if (IOUAmount.issuer !== this.Account.address) {
        // check IOU balance
        const sourceLine = await this.accountTracker.getFilteredAccountLine(this.Account.address, IOUAmount);
        if (!sourceLine) {
          return;
        }

        // check if asset is frozen by issuer
        if (sourceLine.freeze_peer) {
          throw new Error("Token is freezed, please unfreeze first");
        }
        if (Number(IOUAmount.value) > Number(sourceLine.balance)) {
          throw new Error(`Insufficient spendable token balance, current balance is: ${Number(sourceLine.balance)} and required is:  ${Number(IOUAmount.value)}`);
        }
      } else {
        // sender is the issuer
        // check for exceed the TrustLine Limit on obligations
        const sourceLine = await this.accountTracker.getFilteredAccountLine(this.Account.address, {
          issuer: this.Destination.address,
          currency: IOUAmount.currency
        });
        if (!sourceLine) {
          return;
        }
        // https://xrpl.org/account_lines.html#response-format
        // balance can be negative or positive depends on whether sends owes or holds tokens.
        // balance is a shared state between sender and receiver so if balance is negative it means
        // sender owes value to receiver and vice versa.
        if (Number(IOUAmount.value) + Math.abs(Number(sourceLine.balance)) > Number(sourceLine.limit_peer)) {
          throw new Error("TrustLine limit is exceeded.");
        }
      }
    }
  }
}
_defineProperty(Payment, "Type", TransactionTypes.Payment);

class TrustSet extends BaseTransaction {
  constructor(config, tx) {
    super(config, tx);
    this.fields = this.fields.concat(["LimitAmount", "QualityIn", "QualityOut"]);
  }
  async validate() {
    await super.validate();
    validateTrustSet(this.tx);
  }
}

class TransactionFactory {
  static getTransactionInstanceFromJson(txJson, config) {
    let tx;
    if (txJson.TransactionType === TransactionTypes.Payment) {
      tx = new Payment(config, txJson);
    } else if (txJson.TransactionType === TransactionTypes.TrustSet) {
      tx = new TrustSet(config, txJson);
    } else if (txJson.TransactionType === TransactionTypes.NFTokenAcceptOffer) {
      tx = new NFTokenAcceptOffer(config, txJson);
    } else if (txJson.TransactionType === TransactionTypes.NFTokenCreateOffer) {
      tx = new NFTokenCreateOffer(config, txJson);
    } else if (txJson.TransactionType === TransactionTypes.NFTokenCancelOffer) {
      tx = new NFTokenCancelOffer(config, txJson);
    } else {
      tx = new Generic(config, txJson);
    }
    return tx;
  }
}

class TransactionStateManager extends BaseTransactionStateManager {
  constructor(_ref) {
    let {
      config,
      state,
      getCurrentChainId
    } = _ref;
    super({
      config,
      state,
      getCurrentChainId
    });
  }
  wipeTransactions(address) {
    const {
      transactions
    } = this.state;
    const chainId = this.getCurrentChainId();
    this.update({
      transactions: omitBy(transactions, txMeta => txMeta.transaction.Account === address && transactionMatchesNetwork(txMeta, chainId))
    });
  }
  getTransactions() {
    let {
      searchCriteria = {},
      initialList = undefined,
      filterToCurrentNetwork = true
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const chainId = this.getCurrentChainId();
    // searchCriteria is an object that might have values that aren't predicate
    // methods. When providing any other value type (string, number, etc), we
    // consider this shorthand for "check the value at key for strict equality
    // with the provided value". To conform this object to be only methods, we
    // mapValues (lodash) such that every value on the object is a method that
    // returns a boolean.
    const predicateMethods = mapValues(searchCriteria, predicate => typeof predicate === "function" ? predicate : v => v === predicate);

    // If an initial list is provided we need to change it back into an object
    // first, so that it matches the shape of our state. This is done by the
    // lodash keyBy method. This is the edge case for this method, typically
    // initialList will be undefined.
    const transactionsToFilter = initialList ? keyBy(initialList, "id") : this.state.transactions;

    // Combine sortBy and pickBy to transform our state object into an array of
    // matching transactions that are sorted by time.
    const filteredTransactions = sortBy(pickBy(transactionsToFilter, txMeta => {
      // default matchesCriteria to the value of transactionMatchesNetwork
      // when filterToCurrentNetwork is true.
      if (filterToCurrentNetwork && transactionMatchesNetwork(txMeta, chainId) === false) {
        return false;
      }
      // iterate over the predicateMethods keys to check if the transaction
      // matches the searchCriteria
      for (const [key, predicate] of Object.entries(predicateMethods)) {
        // We return false early as soon as we know that one of the specified
        // search criteria do not match the transaction. This prevents
        // needlessly checking all criteria when we already know the criteria
        // are not fully satisfied. We check both txParams and the base
        // object as predicate keys can be either.
        let searchObj = {};
        if (key in txMeta) {
          searchObj = txMeta[key];
        } else if (key in txMeta.transaction) {
          searchObj = txMeta.transaction[key];
        }
        if (Object.keys(searchObj).length === 0 || !predicate(searchObj)) {
          return false;
        }
      }
      return true;
    }), "time");
    return filteredTransactions;
  }
  getApprovedTransactions(address) {
    const searchCriteria = {
      status: TransactionStatus.approved
    };
    if (address) {
      searchCriteria.account = address;
    }
    return this.getTransactions({
      searchCriteria
    });
  }
  getSubmittedTransactions(address) {
    const searchCriteria = {
      status: TransactionStatus.submitted
    };
    if (address) {
      searchCriteria.account = address;
    }
    return this.getTransactions({
      searchCriteria
    });
  }
  getPendingTransactions(address) {
    const submitted = this.getSubmittedTransactions(address);
    const approved = this.getApprovedTransactions(address);
    return [...submitted, ...approved];
  }
  getConfirmedTransactions(address) {
    const searchCriteria = {
      status: TransactionStatus.confirmed
    };
    if (address) {
      searchCriteria.account = address;
    }
    return this.getTransactions({
      searchCriteria
    });
  }
  getTransactionsByHash(hash) {
    const chainId = this.getCurrentChainId();
    const transactions = pickBy(this.state.transactions, transaction => transaction.transactionHash === hash && transactionMatchesNetwork(transaction, chainId));
    return transactions;
  }
  addTransactionToState(txMeta) {
    this.on(`${txMeta.id}:signed`, () => {
      this.removeAllListeners(`${txMeta.id}:rejected`);
    });
    this.on(`${txMeta.id}:rejected`, () => {
      this.removeAllListeners(`${txMeta.id}:signed`);
    });
    this._addTransactionsToState([txMeta]);
    const transactions = this.getTransactions({
      filterToCurrentNetwork: false
    });
    const txToKeep = this.trimTransactionsForState(transactions);
    this._setTransactionsToState([...txToKeep]);
    this.emit(`${txMeta.id}:unapproved`, txMeta);
    return txMeta;
  }

  /**
   * Trim the amount of transactions that are set on the state. Checks
   * if the length of the tx history is longer then desired persistence
   * limit and then if it is removes the oldest confirmed, rejected, failed, expired tx.
   * Pending or unapproved transactions will not be removed by this
   * operation. For safety of presenting a fully functional transaction UI
   * representation, this function will not break apart transactions with the
   * same id, created on the same day, per network. Not accounting for transactions of the same
   * nonce, same day and network combo can result in confusing or broken experiences
   * in the UI. The transactions are then updated using the BaseController update.
   * @param transactions - arrray of transactions to be applied to the state
   * @returns Array of TransactionMeta with the desired length.
   */
  trimTransactionsForState(transactions) {
    const txhashNetworkSet = new Set();
    const txsToKeep = transactions.reverse().filter(tx => {
      const {
        chainId,
        status,
        transaction,
        time,
        transactionHash
      } = tx;
      if (transaction) {
        const key = `${transactionHash}-${chainId}-${new Date(time).toDateString()}`;
        if (txhashNetworkSet.has(key)) {
          return false;
        } else if (txhashNetworkSet.size < this.config.txHistoryLimit || !this.isFinalState(status)) {
          txhashNetworkSet.add(key);
          return true;
        }
      }
      return false;
    });
    txsToKeep.reverse();
    return txsToKeep;
  }
}

class TransactionController extends TransactionStateManager {
  /**
   * Creates a TransactionController instance
   *
   * @param config - Initial options used to configure this controller
   * @param state - Initial state to set on this controller
   */
  constructor(_ref) {
    let {
      config,
      state,
      ledgerTracker,
      accountTracker,
      getCurrentChainId,
      signTransaction,
      provider
    } = _ref;
    super({
      config,
      state,
      getCurrentChainId
    });
    /**
     * Name of this controller used during composition
     */
    _defineProperty(this, "name", "TransactionController");
    _defineProperty(this, "mutex", new Mutex());
    _defineProperty(this, "signTransaction", void 0);
    _defineProperty(this, "pendingTxTracker", void 0);
    _defineProperty(this, "ledgerTracker", void 0);
    _defineProperty(this, "accountTracker", void 0);
    _defineProperty(this, "provider", void 0);
    _defineProperty(this, "accountSequenceTracker", void 0);
    _defineProperty(this, "getPendingTxCount", address => this.getPendingTransactions(address).length);
    _defineProperty(this, "getTransactionReceiptByHash", hash => {
      const transactions = this.getTransactionsByHash(hash);
      const txList = Object.values(transactions);
      const tx = txList[0];
      return tx.txReceipt ? tx.txReceipt : undefined;
    });
    this.signTransaction = signTransaction;
    this.provider = provider;
    this.pendingTxTracker = new PendingTransactionTracker({
      provider,
      getPendingTransactions: this.getPendingTransactions.bind(this),
      emit: this.emit.bind(this)
    });
    this._setupListeners();
    this.getCurrentChainId = getCurrentChainId;
    this.ledgerTracker = ledgerTracker;
    this.accountTracker = accountTracker;
    this.accountSequenceTracker = new AccountSequenceTracker({
      accountTracker,
      getPendingTransactions: this.getPendingTransactions.bind(this)
    });
  }
  getUnapprovedTxCount() {
    return Object.keys(this.getUnapprovedTxList()).length;
  }
  async sync(ledgerState) {
    try {
      await this.pendingTxTracker.updatePendingTxs(ledgerState);
    } catch (error) {
      log.error(error);
    }
  }
  getTransactionInstanceFromJson(transaction) {
    const txInstance = TransactionFactory.getTransactionInstanceFromJson(transaction, {
      signTransaction: this.signTransaction.bind(this),
      ledgerTracker: this.ledgerTracker,
      accountTracker: this.accountTracker,
      provider: this.provider,
      accountSequenceTracker: this.accountSequenceTracker
    });
    return txInstance;
  }

  /**
   * Add a new unapproved transaction to state.
   * @param transaction - Transaction object to add
   * @returns - Object containing a promise resolving to the transaction hash if approved
   */
  async addTransaction(transaction, txOptions, req) {
    const txInstance = TransactionFactory.getTransactionInstanceFromJson(transaction, {
      signTransaction: this.signTransaction.bind(this),
      ledgerTracker: this.ledgerTracker,
      accountTracker: this.accountTracker,
      provider: this.provider,
      accountSequenceTracker: this.accountSequenceTracker
    });
    console.log("created tx instance", txInstance.Json);
    if (!txOptions.multisign) {
      if (!txInstance.Fee) {
        await txInstance.loadTransactionFee();
      }
      await txInstance.prepare();
      txInstance.populateLastLedgerSequence();
    }
    console.log("populated tx instance", txInstance.Json);
    const chainId = this.getCurrentChainId();
    if (txInstance.Hash) {
      // it will throw error if invalid deploy/transaction json is passed
      const txHash = txInstance.Hash;
      const index = Object.values(this.state.transactions).findIndex(_ref2 => {
        let {
          transactionHash
        } = _ref2;
        return transactionHash === txHash;
      });
      if (index !== -1) {
        throw new Error("transaction with provided hash already exist");
      }
    }
    console.log("validated tx list");
    const transactionMeta = {
      id: randomId(),
      transactionType: transaction.TransactionType,
      dappSuggestedTransaction: {},
      chainId,
      origin: req.origin,
      status: TransactionStatus.unapproved,
      time: Date.now(),
      transaction: txInstance.Json,
      transactionHash: txInstance.Hash,
      transactionOptions: {
        multisign: txOptions.multisign,
        method: req.method
      }
    };
    const result = new Promise((resolve, reject) => {
      this.once(`${transactionMeta.id}:finished`, meta => {
        console.log("meta", meta);
        switch (meta.status) {
          case TransactionStatus.signed:
            return resolve(meta.transactionHash);
          case TransactionStatus.submitted:
            return resolve(meta.transactionHash);
          case TransactionStatus.rejected:
            return reject(new Error("User rejected the transaction"));
          case TransactionStatus.cancelled:
            return reject(new Error("User cancelled the transaction"));
          case TransactionStatus.expired:
            return reject(new Error("Transaction has been expired"));
          case TransactionStatus.failed:
            return reject(new Error(meta.error.message));
          /* istanbul ignore next */
          default:
            return reject(new Error(`Torus Tx Signature: Unknown problem: ${JSON.stringify(meta)}`));
        }
      });
    });
    console.log("adding tx to state");
    this.addTransactionToState(transactionMeta);
    console.log("addedtx to state");
    this.emit(TX_EVENTS.TX_UNAPPROVED, {
      txMeta: transactionMeta,
      req
    });
    return {
      result,
      transactionMeta
    };
  }

  /**
   * Approves a transaction and updates it's status in state.
   *
   * @param transactionID - ID of the transaction to approve
   * @returns - Promise resolving when this operation completes
   */
  async approveTransaction(transactionID) {
    const {
      transactions
    } = this.state;
    const releaseLock = await this.mutex.acquire();
    const transactionMeta = transactions[transactionID];
    const currentChainId = this.getCurrentChainId();
    let txInstance;
    try {
      var _transactionMeta$tran, _transactionMeta$tran2, _transactionMeta$tran3;
      if (!currentChainId) {
        this.setTxStatusFailed(transactionMeta.id, new Error("No chainId defined."));
        return;
      }
      txInstance = TransactionFactory.getTransactionInstanceFromJson(transactionMeta.transaction, {
        signTransaction: this.signTransaction.bind(this),
        ledgerTracker: this.ledgerTracker,
        accountTracker: this.accountTracker,
        provider: this.provider,
        accountSequenceTracker: this.accountSequenceTracker
      });
      await txInstance.validate();
      this.setTxStatusApproved(transactionMeta.id);
      console.log("approve txn", txInstance, transactionMeta.transaction);
      await txInstance.sign(txInstance.Account, !!((_transactionMeta$tran = transactionMeta.transactionOptions) !== null && _transactionMeta$tran !== void 0 && _transactionMeta$tran.multisign));
      console.log("signed tx");
      this.setTxStatusSigned(transactionMeta.id, !!((_transactionMeta$tran2 = transactionMeta.transactionOptions) !== null && _transactionMeta$tran2 !== void 0 && _transactionMeta$tran2.multisign));
      if (((_transactionMeta$tran3 = transactionMeta.transactionOptions) === null || _transactionMeta$tran3 === void 0 ? void 0 : _transactionMeta$tran3.method) !== RPC_METHODS.SIGN_TRANSACTION) {
        await txInstance.submit();
        transactionMeta.transactionHash = txInstance.SubmitResult.hash;
        log.debug("txInstance.SubmitResult", txInstance.SubmitResult, txInstance.Hash, transactionMeta);
        this.updateTransaction(transactionMeta);
        if (txInstance.SubmitResult.success && txInstance.SubmitResult.engineResult === "tesSUCCESS") {
          this.setTxStatusSubmitted(transactionMeta.id);
        } else {
          this.setTxStatusFailed(transactionMeta.id, new Error(txInstance.SubmitResult.message || "Something went wrong"));
        }
      } else {
        console.log(" txInstance.Json", txInstance.SignedBlob, txInstance.Json);
        transactionMeta.transaction = txInstance.Json;
        this.updateTransaction(transactionMeta);
        this.setTxStatusSigned(transactionMeta.id, true);
      }
    } catch (error) {
      log.warn("error while approving transaction", error);
      this.setTxStatusFailed(transactionMeta.id, error);
    } finally {
      var _txInstance;
      releaseLock(); // Release lock for transaction
      (_txInstance = txInstance) === null || _txInstance === void 0 || _txInstance.releaseAccountLock(txInstance.Account); // Release lock for account
    }
  }
  _setupListeners() {
    this.on(TX_EVENTS.TX_WARNING, data => {
      this.updateTransaction(data.txMeta);
    });
    this.on(TX_EVENTS.TX_DROPPED, data => this.setTxStatusDropped(data.txId));
    this.on(TX_EVENTS.TX_EXPIRED, data => this.setTxStatusExpired(data.txId));
    this.on(TX_EVENTS.TX_FAILED, data => {
      this.setTxStatusFailed(data.txId, data.error);
    });
    this.on(TX_EVENTS.TX_CONFIRMED, data => this.confirmTransaction(data.txId, data.txReceipt));
  }
  async confirmTransaction(txId, txReceipt) {
    const txMeta = this.getTransaction(txId);
    if (!txMeta) {
      return;
    }
    txMeta.txReceipt = txReceipt;
    this.updateTransaction(txMeta);
    this.setTxStatusConfirmed(txId);
  }
}

export { AccountTrackerController, BaseTransaction, CDBC_FAUCET_URL, CHAINS, CHAIN_ID_NETWORK_MAP, ChainConfigController, CurrencyController, DEFAULT_CDBC_FAUCET_FUND_AMOUNT, DEFAULT_XRPL_CHAIN_CONFIGS, DEFAULT_XRPL_CHAIN_NETWORK_KEYS, DEFAULT_XRPL_NETWORK, DefaultXrplNetworkArray, KeyringController, LedgerObjectFlags, LoadingState, MESSAGE_EVENTS, MessageStatus, MessageManager as MessagesController, NATIVE_TRANSFER_GAS, NFTOKEN_NOT_TRANSFERABLE, NetworkController, NftsTrackerController, OTHER_TRANSACTIONS, PAYMENT_NO_TRUSTLINE_ERROR_MSG, Payment, PollingLedgerTracker as PollingLedgerController, PreferencesController, RIPPLE_API_ISSUED_CURRENCIES, RIPPLE_SANDBOX_API_ISSUED_CURRENCIES, RIPPLE_TESTNET_FAUCET_URL, RPC_METHODS, SUPPORTED_SUBMIT_TRANSACTION_TYPES, TOKEN_PRICE_AGGREGATOR_URL, TRANSFER_MINIMUM_AMOUNT, TokensInfoController, TokensTrackerController, TransactionController, TransactionFactory, TransactionSerializer, TransactionTypes, XRPL_META_TOKENS_BASE_URL, XRPL_TRANSACTION_TYPES, XrplJrpcService, _checkIfTxExpired, createChainIdMiddleware, createGenericJRPCMiddleware, createGetAccountsMiddleware, createJsonRpcClient, createProviderConfigMiddleware, createXRPLMiddleware, formatAccountTx, formatNewTransaction, formatPastTx, formatTxToSave, fundAccountFromXrplFaucet, getDefaultXRPLChainConfig, getSupportedTokensOmitPrice, getTokensPrice, getTransactionType, getTxStatus, isHex40Currency, parseCurrencyToReadableFormat };
//# sourceMappingURL=xrplControllers.esm.js.map
